import { HOST } from './host';

export const common = {
  // 通用接口
  phpUrl: HOST,
  // 地区区号
  areaCode: 'json_tools_areacodelistformat',
  // 根据ip获取手机号归属地
  getPhoneArea: 'json_ip_get-ip-info',
  // 筛选组件 获取人员列表
  personList: 'json_search_doc-person',

  // 路演列表
  roadshowList: 'json_roadshow-list_all',
  // 路演鉴权
  roadshowAuth: 'json_event_noticepageauth',

  // 路演 ai会记
  roadshowAinote: 'json_roadshow_ainote',
  // 路演 ai会记确认弹窗
  roadshowAinoteConfirm: 'json_roadshow_ainote-confirm',

  // 调研活动列表
  researchActivityList: 'json_research_activity-list',
  // 研报
  reportList: 'json_research_search',
  // 问答
  questionList: 'json_qa_pagelist',
  // 纪要
  summaryList: 'json_roadshow-list_summary',
  // 筛选条件
  getNewFilterConfigList: 'json_business_tag400',
  // 查询企业下的服务专员
  orgCustomerService: 'json_customer_org-customer-service',
  // 热词统计、添加搜索记录
  hotSearchCollect: 'json_hotsearch_collect',
  // 搜索词联想
  wordHints: 'api_search_completion-hints',

  queryTagIndustry: 'json_tag_industry',

  upload: 'json_oss_signature',

  /** OSS：指定目录下直接子文件与子文件夹（/json/oss/file/list） */
  ossFileList: 'json_oss_file-list',

  /** OSS：获取指定对象的 GET 预签名 URL（/json/oss/file-presigned-url） */
  ossFilePresignedUrl: 'json_oss_file-presigned-url',

  /** OSS：文件复制（/json/oss/file-copy） */
  ossFileCopy: 'json_oss_file-copy',

  // 获取机构logo
  orgLogo: 'json_brm-org_info',

  commonConfig: 'json_biz_common-config',
  // 用户关注或取消关注行业
  industryOperation: 'json_industry_operation-industry',
  // 反馈类型列表
  feedbackTypeList: 'json_feedback_question',
  // 提交反馈
  feedbackSubmit: 'json_feedback_submit',

  // 添加浏览记录
  addUserBrowse: 'json_common_content-add-user-browse',

  // 查询会员试用领取条件信息
  getMemberShipFreeActivity: 'json_membership-freeactivity_get-info',
  // 会员试用 - 立即领取
  receiveMemberTryout: 'json_membership-freeactivity_receive',
  // 会员试用 - 提醒设置
  setMemberRemind: 'json_membership-freeactivity_set-remind',
  // 会员试用 - 问卷
  sumbitQuestion: 'json_membership-freeactivity_question',
  // 弹框信息
  freeactivityWindow: 'json_membership-freeactivity_window',
  // 查询问卷调查信息
  freeactivityQueryQuestion: 'json_membership-freeactivity_query-question',

  uploadLog: 'json_sts_get-sls-credentials',
  // 分片上传
  chunkUpload: 'json_upload_ststoken',
  /** 获取一级行业列表 */
  tierOneIndustries: 'json_get_first-industry',
  // 获取公共配置
  getCommonConfig: 'json_biz_get-org-config',
  // 获取最新版本
  versionLastVersion: 'json_version_last-version',
  // 版本更新已读上报
  versionAddUserBrowse: 'json_version_add-user-browse',
  // 批量获取用户生效中的会员信息
  getUserMemberEquityList: 'member_equity_list-user-member-effective',
  // 获取浏览记录
  getUserBrowse: 'json_common_get-user-browse',
  /** 查询当前用户今日是否需要弹窗（Query: type，1=会员挽留弹框） */
  popupCheck: 'json_popup_check',
  /** 记录当前用户今日已弹窗（POST body: type，1=会员挽留弹框） */
  popupRecord: 'json_popup_record',
  // 保存成员交互
  saveInteraction: 'user_interaction_save-interaction',
  // 获取用户mcp密钥
  getUserMcpKeyInfo: 'json_copaw_mcp-key-config',
  /** 预留：MCP 服务配置列表（查看个人密钥弹窗中「进门 MCP / 我的应用」） */
  mcpServiceConfigList: 'json_copaw_mcp-service-config-list',

  // 用户习惯相关
  saveUserPreference: 'json_user-preference_save',
  getUserPreferenceList: 'json_user-preference_select-list',
  // SRS工作台
  getSrsWorkbench: 'json_srs_workbench',
  getIrmToken: 'irmuser/irm/user/login/comein-token'
};

export const thirdPartyOauth = {
  // WorkBuddy 账号绑定
  bindingBind: 'json_binding_bind',
  // WorkBuddy 授权码换取绑定状态（已绑定时顺带下发 comein 会话）
  bindingLogin: 'json_binding_login',
  // 解除 WorkBuddy 与当前登录账号的绑定关系
  bindingUnbind: 'json_binding_unbind'
};

export const login = {
  // 退出登录
  weblogout: 'json_user_weblogout',
  // 帐号密码登录
  weblogin: 'json_user_weblogin',
  // 手机号登录
  phonelogin: 'json_user_phonelogin',
  // 二维码登录
  qrcodelogin: 'json_user_qrcodelogin',
  // 查询用户企业列表
  orgList: 'json_identity_query-user-org',
  // 切换用户登录身份
  switchIdentity: 'json_identity_change-user-identity',
  // 登录弹窗---获取手机验证码(可不同类型)
  getPhoneCode: 'json_user_getphoneauth',
  // 获取邮箱验证码/验证码登录
  getemailauth: 'json_user_emaillogin',
  // 根据token查询用户缓存信息 --- 暂时不用
  userquery: 'json_user_query',
  // 查询会员权益
  checkMemberBenefit: 'json_membership_check-uid-benefit',
  // 查询用户开通会员信息
  queryUserMembership: 'json_membership_query-user-membership',
  // 登录弹窗---邮箱忘记密码重置密码
  findPwdByEmail: 'json_account_find-password-by-email',
  // 登录弹窗---校验手机验证码(可不同类型)
  checkPhoneCode: 'json_user_checkphoneauth',
  // 登录弹窗---账号重置密码（通过手机号）
  resetPwd: 'json_user_resetpassword',
  // 邀请通知
  invite: 'json_identity_query-user-identity-and-invite',
  // 忽略邀请
  ignoreInvite: 'json_brm_ignore-invitation-notification',
  // 通过邀请
  acceptInvite: 'json_identity_join-by-invitation-notification',
  // 取消注销申请
  cancelApply: 'json_cancellation_cancel-apply',
  // 获取角色菜单
  getRoleModule: 'json_author_query-user-role-module',
  // 获取用户信息
  getUserInfo: 'json_brm-user_get-info',
  // 获取用户详情（含 complianceRestricted：是否合规受限用户 1=是/0=否）
  getUserDetail: 'json_user_userdetail',
  // 合规受限用户超时退出登录
  complianceLogout: 'json_user_compliance-logout'
};

export const openClaw = {
  // 获取分配的虚拟机
  getAssignedMachine: 'json_copaw_allocate',
  // 初始化当前登录用户的 Sandbox
  initSandbox: 'json_sandbox_init',
  // 检查是否需要升级 copaw
  needUpdateVersion: 'json_copaw_need-update-version',
  // 升级 copaw 到最新版本
  updateCopawVersion: 'json_copaw_update-copaw-version',
  // 导入技能
  importSkill: 'json_copaw_import-skill',
  // 获取MCP工具
  getMcpTools: 'json_mcp-client_tools',
  // 检查是否有投研龙虾资源(分配了云电脑)
  hasAvailableResource: 'json_copaw_has-available-resource',
  // 获取快速提问
  quickQuestions: 'json_copaw_quick-questions',
  /** 云电脑资源总览（可兑换档位、资源列表等） */
  resourceOverview: 'json_copaw_resource-overview',
  /** 云电脑兑换时长（body: packageCode） */
  exchangeDuration: 'json_copaw_exchange-duration'
};

export const roadshow = {
  //全部路演
  allRow_list: 'json_roadshow_search',
  //BRM路演搜索
  roadshowSearchForBRM: 'json_roadshow_search-for-brm',
  // 自助会议 活动-路演-全部/A股/港股/美股 列表查询（自助会议）
  roadshowMeetForBRM: 'json_meetingactivity_list',
  // 活动-路演热榜列表
  roadshowHotList: 'json_meetingactivity_hot-list',
  // 自助会议 活动-路演-全部/A股/港股/美股 日历按时间维度统计数量（自助会议）
  roadshowMeetCountByDay: 'json_meeting-activity_count-by-day',
  // 市场活动，我司 的调研活动日历数量(颗粒度为小时)
  researchMarketActivityCount: 'json_research_market-activity-count-hour',
  // 策略会统计数量（颗粒度小时）
  strategyCount: 'json_strategy_count-ongoing-day',
  // 路演预告
  preview_list: 'json_roadshow_advance',
  //我的收藏
  attlist_list: 'json_event_attlist',
  //历史记录
  history_list: 'json_roadshow_watchlist',
  // 收藏关注
  attentionevent: 'json_event_attentionevent',
  // 筛选项
  analyst_search: 'json_business_tag383',

  // 预约路演/取消预约
  appointment: 'json_roadshow_appointment',
  // 我司日历日视图列表
  orgCalendarList: 'json_orgcalendar_list',
  // 我司日历按天统计数量（仅正常活动，orgId 不传时取登录用户的组织id）
  orgCalendarCountByDay: 'json_orgcalendar_count-by-day',
  // 我司日历预约/取消预约
  orgCalendarAppointment: 'json_orgcalendar_appointment',
  // 自助会议 预约路演/取消预约（自助会议）
  appointmentMeet: 'json_meet_appointment',
  // 调研活动
  activityList: 'json_research_activity-list',
  // 日程-我的-查询
  myScheduleList: '/brm/manage/schedule/list',
  // 日程-我的-新增日程
  otherThingsMeetAdd: 'json_dateschedule_create',
  // 日程-我的-数量
  getWeekScheduleCount: 'json_dateschedule_list-by-day',
  // 日程-今日数量（侧边栏日历角标）
  getTodayScheduleCount: 'json_dateschedule_today-count',
  // 日程-标记今日已查看（点击日历菜单后清除角标）
  markTodayScheduleViewed: 'json_dateschedule_mark-today-viewed',
  // 日程-我的-查详情
  otherThingsMeetDetail: 'json_dateschedule_detail',
  // 日程-我的-修改
  otherThingsMeetEdit: 'json_dateschedule_update',
  // 日程-我的-删除
  otherThingsMeetDelete: 'json_dateschedule_delete',
  // 日程-我的-修改重要标识
  changeImportantTips: 'json_dateschedule_change-important',
  updateNotifySetting: 'json_dateschedule_set-notify-type',

  // 个股相关路演
  companyList: 'json_brm-roadshow_company-roadshow',
  // 个股banner路演
  performanceList: 'json_brm-roadshow_performance-roadshow',
  // 个股banner路演
  industryPerformanceList: 'json_roadshow-list_performance',
  // 全部路演
  allRoadshow: 'json_roadshow-list_all',
  // 全部路演
  themeRoadshow: 'json_roadshow-list_theme',

  // 官网获取路演——用于不区分直播回放的路演鉴权
  joinliveroom: 'json_roadshow_joinliveroom',

  //路演稍纵即逝 - 无回访
  playbackNo: 'json_roadshow-list_no-playback',
  //路演稍纵即逝 - 限时回放
  playbackLimited: 'json_roadshow-list_playback-limited',
  //路演列表 - 点击
  roadshowClick: 'json_roadshow_click',
  //路演列表 - 点击记录
  roadshowClickHistory: 'json_roadshow_click-history',

  // 路演预告
  advanceList: 'json_roadshow-list_preview',
  // 自助会议 活动-路演-推荐-直播预告 列表（自助会议）
  advanceMeetList: 'json_meetingactivity_preview',
  // 行业专家 - 路演
  industryExpert: 'json_meetingactivity_industry-specialist',
  // 上司公司 - 路演
  parentCompany: 'json_roadshow-list_public-company',
  // 分析师 - 路演
  analyst: 'json_meetingactivity_analyst',
  // 热门搜索 - 路演
  hotSearch: 'json_roadshow-list_popular',
  // 机构通 - 路演
  instutitionList: 'json_meetingactivity_institution',
  // 活动路演 推荐 根据行业分组计算路演数
  roadshowCount: 'json_meeting-activity_count-by-industry',
  // 活动路演 推荐 根据特色分组计算路演数
  roadshowCountByFeature: 'json_meeting-activity_count-by-tag',
  // 活动路演 推荐 根据组织分组计算路演数
  roadshowCountByOrg: 'json_meeting-activity_count-by-organization',
  // 活动路演 推荐 当天路演数量
  roadshowCountToday: 'json_meeting-activity_count-by-status',
  // 按时间维度统计会议活动数量
  roadshowCountByDay: 'json_meeting-activity_count-by-day',
  // 个人信息 报名信息 查询用户预报名信息
  querySignupInfo: 'json_signup_query-signup-information',
  // 个人信息 报名信息 保存用户预报名信息
  saveSignupInfo: 'json_signup_save-signup-information',
  // 自动报名开关设置
  setAutoSignupInfo: 'json_signup_auto-signup-set',
  // 专题自动预约开关
  topicAutoAppointment: 'json_topic_auto-appointment',
  // 近期回顾
  roadshowPlayback: 'json_meetingactivity_playback',

  // 获取收藏路演列表
  roadshowCollectionList: 'json_brm-roadshow_sub-list',
  // 路演历史记录列表
  roadshowHistoryList: 'json_brm-roadshow_history-list'
};

// 研报
export const reportManage = {
  // 筛选条件
  getNewFilterConfigList: 'json_business_tag400',
  // 观点列表
  getViewpointList: 'json_research_search-summary-point',
  // 研报列表
  getReportList: 'json_research_search',
  // VIP研报列表
  getVIPReportList: 'json_research_query-vip-list',
  // 外资研报列表
  getOverseasReportList: 'json_oversea-research_search',
  // 外资研报列表 - 中文机构列表
  queryOverseasFilterOrgchn: 'json_oversea-research_organization',
  // 研报详情
  getReportDetail: 'json_research_detail',
  // 研报数量
  reportDayCount: 'json_research_count',
  // 支付牛币
  payNiuBi: 'json_user_pay-nbi',
  // 我的钱包
  mywallet: 'json_wallet_mywallet',
  // 获取收藏研报列表
  reportCollectionList: 'json_research_collectlist',
  // 外资研报数量
  foreignCapitalReportDayCount: 'json_oversea-research_count',
  // 获取收藏外资研报列表
  reportCollectList: 'json_oversea-research_collect-list',
  // 获取历史记录外资研报列表
  browseHistoryList: 'json_oversea-research_browse-history-list',
  // 获取历史记录外资研报列表-仅查询最近3个月
  overseaResearchHistoryListLimit: 'json_oversea-research_browse-record-list',
  // 添加收藏记录
  getCollectionRecordAdd: 'json_research_collect',
  // 研报历史记录
  userReportBrowse: 'json_research_browse-history-list',
  // 研报历史记录-仅查询最近3个月
  userReportBrowseLimit: 'json_research_browse-record-list',
  // 同行业热门研报
  industryHotReport: 'json_research_industry-hot-list',
  // 往期研报
  reportList: 'json_research_list',
  // 清除历史浏览记录（纪要，研报）
  reportHistoryListCancel: 'json_research_delete-browse-history',
  // 我的收藏
  getMyAttention: 'json_research_attention-stock-list',
  //外资研报详情
  getForeignCapitalReportDetail: 'json_oversea-research_detail',
  //外资研报相关推荐列表
  getForeignCapitalRelatedList: 'json_oversea-research_hot-list',
  //获取翻译限额
  getTranslateLimit: 'json_research-report-trans_get-translate-limit',
  //发起翻译请求-外资研报
  foreignCapitalTranslate: 'json_research-report-trans_translate-oversea',
  //获取翻译结果-外资研报
  getTransitionResult: 'json_research-report-trans_get-translate-result',
  //外资研报收藏
  foreignCapitalCollect: 'json_oversea-research_collect',
  //清空外资研报收藏(全部)
  clearCollect: 'json_oversea-research_clear-collect',
  //清空历史记录(全部)
  clearBrowseHistory: 'json_oversea-research_clear-browse-history',
  //外资研报阅读排行
  getReadingRankingList: 'json_oversea-research_read-ranking-list',
  //内资研报&观点阅读排行
  getDomesticCapitalReadingRankingList: 'json_research_read-ranking-list',
  //内资研报详情页相关研报列表
  hotList: 'json_research_hot-list',
  //内资研报详情页分析师往期研报列表
  analystList: 'json_research_analyst-list',
  //内资研报图表
  researchImageList: 'json_research-image_list',
  //点评列表
  getInsightsList: 'json_investment-insights_search',
  // 综合概览 - 研究详情 - 全部
  getAllList: 'json_search_universal',
  //综合概览 - 点评
  attentionInsightsList: 'json_investment-insights_common-search',
  // 点评详情
  insightsDetail: 'json_investment-insights_detail',
  /** 点评收藏 */
  insightsCollect: 'json_investment-insights_collect',
  /** 获取点评收藏列表 */
  getCollectInsightsList: 'json_investment-insights_collect-list',
  /** 获取点评浏览历史列表 */
  getInsightBrowsingHistoryList: 'json_investment-insights_browse-list',
  /** 获取点评浏览历史列表-仅查询最近3个月 */
  getInsightBrowsingHistoryListLimit: 'json_investment-insights_browse-record-list',
  /** 点评-用户浏览记录删除 */
  deleteInsightBrowsingHistory: 'json_investment-insights_browse-del',
  //综合概览 - 研报
  attentionViewpointList: 'json_stock-group_research-summary-list',
  //实时外资研报预览
  overseaResearchPreview: 'json_oversea-research_preview',
  //解锁外资研报
  overseaResearchUnlock: 'json_oversea-research_unlock',
  //解锁外资研报(用牛币)
  overseaResearchUnlockNbi: 'json_oversea-research_nbi-unlock',
  //获取会员类型（判断新老会员）
  getMembershipType: 'json_oversea-research_membership',
  // 外资研报基础信息
  overseaResearchBaseinfo: 'json_oversea-research_oversea-research-baseinfo',
  // 点评详情
  getInsightsQueryById: 'json_investment-insights_query-by-id',
  // 用户收藏内资研报列表
  userCollectResearchList: 'json_research_my-collect-filters',
  // 用户历史记录内资研报列表
  userHistoryResearchList: 'json_research_browse-history-list',
  // 用户收藏外资研报列表
  userOverseaCollectResearchList: 'json_oversea-research_my-collect-filters',
  // 用户解锁外资研报列表
  userOverseaUnlockResearchList: 'json_oversea-research_my-unlock-filters',
  // 用户翻译外资研报列表
  userOverseaTranslateResearchList: 'json_oversea-research_my-translate-filters',
  // 用户历史记录外资研报列表
  userOverseaHistoryResearchList: 'json_oversea-research_browse-history-list',
  // 内资研报下载
  researchDownload: 'json_research_download',
  // 外资研报下载
  overseaResearchDownload: 'json_oversea-research_download',
  // 研报阅读位置保存（内资）
  saveReadPosition: 'json_research_save-read-position',
  // 研报阅读位置保存（外资）
  overseaResearchSaveReadPosition: 'json_oversea-research_save-read-position'
};

// 日程
export const scheduleManage = {
  brmActivityDetail: 'json_research_activity-detail',
  getAutoBookingStatus: 'json_auto-appointment_query',
  setAutoBookingStatus: 'json_auto-appointment_setting',
  myRoadshows: 'json_meetingactivity_my-roadshows',
  userMeetingConfigQuery: 'json_user-meeting-config_query',
  userMeetingConfigSave: 'json_user-meeting-config_save'
};

export const summary = {
  // 智能纪要
  summaryInfo: 'json_summary_summary-info',
  // 播放记录上报
  playRecord: 'json_roadshow_watchrecord',
  // 回放开始上报
  statisticRoadshow: 'json_statistic_roadshow',
  // 获取播放记录
  getPlayRecord: 'json_roadshow_watchget',
  // 新-获取播放记录接口
  getPlayRecordNew: 'json_roadshow_user-wat-record',
  // 纪要获取跳转信息的接口
  getSummaryInfo: 'json_summary_summary-info',
  // 获取纪要版本
  getAISummaryContentVersion: 'json_summary_summary-content-new-old',
  // 会议全文
  getAISummaryContentList: 'json_summary_summary-content-list',
  // 章节速览/问答整理
  getAIChapterSummaryList: 'json_summary_list-ai-chapter-summary',
  // 数据指标
  summaryQueryAiIndicatorList: 'json_summary_query-summary-index-list',
  // 筛选条件
  getNewFilterConfigList: 'json_business_tag400',
  // 查询接口/我的收藏-纪要
  querySummaryPage: 'json_roadshow-list_summary',
  //查询合作纪要列表
  querySummaryThirdPage: 'json_summary_cooperation-list',
  // 查询纪要数量接口 暂时使用
  querySummaryCount: 'json_summary_summary-collection-count',
  // 热门纪要接口
  queryHotSummaryPage: 'json_summary_hot-summary-pagelist',
  // 会员纪要接口
  queryVIPSummaryPage: 'json_third-research-summary_query-vip-list',
  // 纪要详情页面-收藏/取消收藏
  summaryCollection: 'json_summary_attention-summary',
  // 纪要详情页面-批量取消收藏
  summaryCollectionCancel: 'json_summary_batch-cancel-sub-summary',
  // 历史记录-纪要
  summaryHistoryList: 'json_summary_summary-browse-record',
  // 历史记录-纪要-仅查询最近3个月
  summaryHistoryListLimit: 'json_summary_browse-record-list',
  // 纪要数量
  summaryCountStatistics: 'json_summary_summary-count',
  // 纪要详情-权限接口
  checkUserBenefit: 'json_summary_membership-auth',
  // 会议数据
  getSummaryConferenceInfo: 'json_summary_check-play-auth',
  // 获取纪要音频播放地址
  getSummaryPlayUrl: 'json_summary_query-play-url',
  // 要点总结
  querySummaryPoints: 'json_summary_query-summary-points',
  // 溯源的接口
  querySummaryPointsTrace: 'json_summary_query-summary-points-trace',
  // 获取行业，上市公司，主讲人，券商机构接口
  selectSummaryBySourceId: 'json_roadshow_query-summary-by-roadshowid',
  // AI纪要的鉴权鉴权接口
  selectAiSummaryByNoteId: 'json_roadshow_query-summary-by-roadshowid-note',
  // 自选-个股-纪要
  queryAttentionSummaryList: 'json_stock-group_summary-list-v2',
  // 问答模板
  commonAiQuestion: 'json_summary_ai-common-question',
  // 历史问答
  listAiQa: 'json_summary_ai-qa-list',
  // 发送消息
  aiQa: 'json_summary_ai-qa',
  // 导出指标数据
  exportAIIndicatorList: 'json_summary_summary-index-export',
  // 埋点纪要详情29-36-0
  buryTheDetails: 'json_statistic_click',
  // 历史记录-纪要-清除
  historyListCancel: 'json_summary-browse_clear',
  // 历史记录-纪要-清除(针对个人中心)
  historyListCancelPersonal: 'json_summary_browse-clear',
  // 获取纪要鉴权
  getSummaryAuth: 'json_summary_detail-page-auth',
  // 获取AI纪要鉴权
  getAISummaryAuth: 'json_summary_detail-page-auth-note',
  // 路演播放文档
  noticepagedocument: 'json_roadshow_noticepagedocument',
  // 路演相关文档
  attachmentlist: 'json_roadshow_attachmentlist',
  // AI纪要 文档摘要列表查询
  docSummary: 'json_summary_query-summary-word-list',
  // AI纪要 文档图片
  pptImages: 'json_summary_query-summary-ppt-images',
  // 文档预览-权限
  summaryDocAuth: 'json_roadshow_pagedocumentauth',
  // 会议-录制文件详情-按钮显示
  jsonMeetingSummaryNoteHasNote: 'json_meeting-summary-note_has-note',
  customizeSummaryDetailsAuth: 'json_summary_customize-summary-details-auth',
  // 纪要要点脑图
  querySummaryPointsMarkMap: 'json_summary_query-summary-points-mark-map',
  // 小会要点脑图
  queryPointsMarkMap: 'json_summary_query-point-mark-map',
  // 纪要要点数说
  querySummaryDataSpeak: 'json_summary_query-summary-data-speaks',
  querySummaryDataSpeakTrace: 'json_summary_query-summary-data-speaks-trace',
  // 获取路演文档向量库信息
  getRoadshowDocVectorInfo: 'json_roadshow-document_query-vectorlib-id',
  // 获取路演文档向量库信息-服务端无权限拦截
  getRoadshowDocVectorInfoWithoutAuthApi: 'json_roadshow-document_query-vectorlib-id-summary',

  // 纪要原文-精炼版翻译
  oriRefinedContent: 'json_summary-trans_ori-refined-content',
  // ai纪要翻译（要点、数说、章节、问答）
  aiSummaryContent: 'json_summary-trans_ai-summary-content',
  // 纪要翻译 - 获取翻译状态
  getTranslationStatus: 'json_summary-trans_summary-tran-status',
  // ai纪要翻译 - 获取翻译状态
  getAiTranslationStatus: 'json_summary-trans_ai-summary-tran-status',
  // 用户相关纪要列表
  userCollectSummaryList: 'json_summary_my-collect-filters',
  userHistorySummaryList: 'json_summary_summary-browse-record'
};

export const research = {
  // 列表查询
  researchList: 'json_research_activity-list',
  // 调研活动报名详情
  researchDetail: 'json_research_activity-detail',
  // 查询近15天的调研活动，按照数量排序取前十条
  researchRecentActivity: 'json_research_recent-activity',
  // 调研添加日程
  researchCreateDateSchedule: 'json_research_create-date-schedule',
  researchDeleteDateSchedule: 'json_research_delete-date-schedule',
  // 研报图表列表
  researchImageSearch: 'json_research-image_search'
};

// 策略会
export const strategy = {
  // 策略会列表
  strategyList: 'json_strategy_activity-list',
  // 策略会列表导出
  strategyListExport: 'json_strategy_activity-list-export',
  // 策略会详情
  strategyDetail: 'json_strategy_activity-detail',
  // 策略会预约
  strategyOrder: 'json_strategy_order'
};

export const market = {
  reportSearch: 'json_research_search',
  reportCount: 'json_research_count',

  stockCountDaily: 'json_stock-detail_count-daily-list',
  stockCountWeekly: 'json_stock-detail_count-weekly-list',
  stockCountMonthly: 'json_stock-detail_count-monthly-list',
  /** 获取 K 线打点（日/周/月统一接口） */
  stockCountKlineList: 'json_stock-detail_count-kline-list',
  // 获取个股全量交易数据列表
  stockClosePriceList: 'json_stock-detail_close-price-list',

  financeDetail: 'json_stock-detail_query-finance-index-detail',

  // 公司简介
  companyProfile: 'json_stock-detail_company-profile',

  researchSummaryList: 'json_research-summary_list',
  // 合作调研纪要
  researchSummaryListThird: 'json_third-research-summary_list',
  // 合作调研纪要详情
  researchSummaryDetailThird: 'json_third-research-summary_detail',
  // 个股
  individualShare: 'json_stock_search-sorted-list',

  // 行业详情
  queryIndustryDetail: 'json_discovery_industry-relate-info',
  // 中证全指
  queryCSIAllIndex: 'json_macro_index-daily-close',
  // 市场&行业热度，接口合并
  queryMarketIndustryTrend: 'json_trend_daily-heat',
  // 市场热度
  discoveryMarketTrend: 'json_discovery_market-trend',
  // 个股热度
  discoveryStockTrend: 'json_discovery_stock-trend',
  // 个股相对一级行业热度
  discoveryStockIndustryRelateTrend: 'json_discovery_stock-industry-relate-trend',
  // 行业热度
  discoveryIndustryTrend: 'json_discovery_get-industry-trend',
  // 发现页热门/冷门行业
  queryIndustryHeatList: 'json_discovery_industry-hot-heat',
  // 热门行业
  queryIndustryHeat: 'json_trend_industry-heat-relation',
  // 热门行业分布
  queryIndustryHeatDistribution: 'json_trend_industry-heat-distribution',
  // 发现页热门股票
  queryHotStocks: 'json_discovery_get-hot-stocks',
  // 行业列表查询
  getIndustryList: 'json_discovery_get-industry-list',
  // 获取行业龙头公司
  getIndustryCompanyList: 'json_discovery_get-industry-companies',
  // 详情页行业热榜
  queryHotIndustry: 'json_discovery_get-hot-industry',
  // 详情页行业相关热门股票
  queryHotStockByIndustry: 'json_stock-hot_industry',
  // 详情页自选分组相关热门股票
  queryHotStockByGroup: 'json_stock-hot_group',

  // 获取个股收盘价数据
  queryStockClosePrice: 'json_discovery_stock-closeprice',
  // 获取个股行为数据
  queryStockBehavior: 'json_discovery_stock-behavior',
  // 获取日k打点（通过类型获取）
  queryStockDailyCount: 'json_stock-detail_count-daily-list-type',
  // 多地上市信息
  getSameStockInfo: 'json_stock-detail_get-same-group-stock-info',
  // 获取公司详情
  getStockDetail: 'json_stock-detail_detail',
  // 个股数据截止日期
  stockTradeDay: 'json_stock_market-max-trade-day',
  //获取个股报告期列表
  fiscalYearList: 'json_stock-financial-report_fiscal-year-list',
  //获取个股业绩期列表
  earningsPeriodList: 'json_stock-financial-report_earnings-period-list',

  // 获取发现页广告位广告列表
  getAdInfoList: 'json_ad_adinfobypage',

  getCompanyResearch: 'json_key-company-research_detail',
  // 重点公司 - 往期报告
  getPreviousReport: 'json_key-company-research_previous-reports',
  // 个股详情路演数量
  getStockRoadShowCount: 'json_meeting-activity_count-by-day',

  //指数行情列表
  queryTradeDataList: 'json_index-market_trade-data-list',

  //热门产业链
  queryIndustrialChainHotList: 'json_industrial-chain_hot-list',
  //产业链自选
  queryIndustrialChainFollowList: 'json_industrial-chain_follow-list',
  //产业链搜索
  queryIndustrialChainSearch: 'json_industrial-chain_search',
  //产业链最近浏览
  queryIndustrialChainListBrowse: 'json_industrial-chain_list-browse',
  //产业链详情
  queryIndustrialChainDetail: 'json_industrial-chain_detail',
  //产业链图谱
  queryIndustrialChainGraph: 'json_industrial-chain_chain-graph',
  //产品题材构成图谱
  queryIndustrialChainThemeConstituteList: 'json_industrial-chain_theme-constitute-list',
  //产业链个股列表
  queryIndustrialChainStockList: 'json_industrial-chain_stock-list',
  //产业链个股基本面
  queryIndustrialChainStockFundmentals: 'json_industrial-chain_stock-fundamentals',
  //产品行情累计涨跌幅
  queryIndustrialChainTotalChangePct: 'json_industrial-chain_index-total-change-pct',
  //产品排序
  queryIndustrialChainSort: 'json_sub-industrial-chain_sort',
  //产品置顶置底
  queryIndustrialChainPin: 'json_sub-industrial-chain_pin',

  //关注专题、行业、券商，股票操作
  subscriptionOperate: 'json_subscription_operate',
  // 因子选股保存
  saveFactorStock: 'json_trend_save-factor-config',
  // 因子选股详情
  factorStockDetail: 'json_trend_query-factor-config',
  // 因子选股股票列表
  factorStockList: 'json_trend_stock-factor-relation',
  // 进门热点
  trendingStockList: 'json_popular-page_ranking-list',
  // K线数据月、周、日
  marketQuotations: 'json_stock-detail_market-quotations',
  // 分钟 K 线 / 分时图
  stockRealtimeKlineHistory: 'json_stock_realtime-kline-history',
  /** 按股票全码批量查询行情 */
  queryStockRealtime: 'json_stock-realtime_change-pct-batch'
};

// 全局搜索
export const search = {
  // 热门搜索
  hotSearch: 'json_search_hotbytype',
  // 热门搜索placeholder
  hotSearchPlaceholder: 'json_searchrecommend_firstlist',
  // 获取分词
  wordSegment: 'json_tokenization_parse-text',
  // 获取文本分词-new
  wordSegmentNew: 'json_search_parse-text-ik',
  // 研报2.0搜索
  reportSearch: 'json_research_search-by-keyword',
  // 路演
  roadshowSearch: 'json_roadshow_search-by-text',
  // 全局搜索统一接口
  globalSearch: 'json_search_search-by-type',
  // 搜索结果高亮
  highlight: 'json_search_get-document-chunk',
  // 纪要
  summarySearch: 'json_roadshow-list_search-summary-by-text',
  // 获取资源下载
  download: 'json_search_get-document-url',
  // 获取资源链接相关信息
  getDocumentInfo: 'json_search_get-documents',
  // 获取搜索配置
  getQuerySetting: 'json_brm-query-setting_query',
  // 保存搜索配置-搜索范围
  saveQuerySetting: 'json_brm-query-setting_save',
  // 搜索补全接口
  searchCompletionHints: 'json_search_completion-hints',
  // 搜索结果今日新增数量（type=2/11/12/13 走 search-by-type 中间层，type=14 走公众号文章列表逻辑）
  todayDocCount: 'json_search_today-doc-count'
};

// 活动
export const activity = {
  // 调研活动 获取每日数量
  getDailyCount: 'json_research_market-activity-list-count'
};

// 分析师相关
export const analyst = {
  interestAnalystList: 'json_analyst_interest',
  interestList: 'json_interest_list',
  subUser: 'json_user_subotheruser',
  analystRank: 'json_rank_analystlist',
  searchAnalyst: 'json_analyst_bannerlist',
  // 分析师基本信息
  analystInfo: 'manage_analyst_info',
  // 分析师查询研报和路演总数
  analystTotalCount: 'manage_analyst_total-count',
  // 分析师荣誉
  analystAwardsRecord: 'manage_analyst_awards-record',
  // 分析师从业经历
  analystRegisterRecord: 'manage_analyst_register-record',
  // 获取分析师用户的路演列表(用户作为主讲人或嘉宾)
  analystRoadshowList: 'json_analyst_roadshowlist',
  // 分析师最近跟踪的内容相关股票
  analystStockLast: 'manage_analyst_stock-last',
  // 分析师最近跟踪的内容相关股票（分页）
  analystStockPage: 'json_analyst_page-stock-analyst',
  // 关注或取关注其他用户
  userSubotheruser: 'json_user_subotheruser',
  // 获取分析师的指定业务数量每日统计
  countStatisticsByType: 'manage_analyst_count-statistics-by-type',
  // 获取分析师基本信息（通过姓名、机构名）
  queryAnalystBaseInfo: 'api_analyst_query-info-by-name',
  //获取股票关注分析师
  stockAttentionAnalyst: 'manage_stock_analyst-list',
  // 获取分析师用户的路演列表（用户作为主讲人或嘉宾）
  stockAnalystRoadshowList: 'manage_stock_analyst-roadshow-list',
  // 获取分析师用户的研报列表
  stockAnalystResearchList: 'manage_stock_analyst-research-list',
  // 获取个股下的分析师列表（分页）
  stockAnalystList: 'manage_stock_analyst-list',
  // 分析师总览数据
  stockAnalystOverview: 'manage_stock_analyst-overview',
  // 分析师业务类型统计打点数据
  stockAnalystCountByType: 'manage_stock_analyst-count-by-type',
  // 分析师打点数据
  stockAnalystALlBizCountList: 'manage_stock_analyst-all-biz-count-list'
};

// 自选
export const articlecenter = {
  // 自选管理 - 自选列表（平铺）
  getGroupList: 'json_stock_group-list',
  // 自选管理 - 分组树形列表（一级含 children）
  getGroupTree: 'json_stock_group-tree',
  /** 查询一级分组下二级分组数量列表（含未分组）/json/stock/group-child-count-list */
  getGroupChildCountList: 'json_stock_group-child-count-list',
  /** 按 fullCode 查询个股所属分组列表（勾选回显）/json/stock/group-list-by-full-code */
  getGroupListByFullCode: 'json_stock_group-list-by-full-code',
  /** 自选管理 - 新建分组/标签（/json/stock/group-add） */
  groupAdd: 'json_stock_group-add',
  /** 自选管理 - 修改分组名称（/json/stock/group-update） */
  stockGroupUpdate: 'json_stock_group-update',
  /** 自选管理 - 删除分组/标签（/json/stock/group-delete） */
  groupDelete: 'json_stock_group-delete',
  // 自选管理 - 更新分组（旧接口，文件管理等仍在使用）
  updateSubGroup: 'json_stock_update-sub-group',
  // 自选管理 - 删除分组（旧接口）
  deleteSubGroup: 'json_stock_delete-sub-group',
  // 自选管理 - 分组层级移动（一级↔二级）
  moveSubGroup: 'json_stock_move-sub-group',
  /** 自选管理 - 分组排序 */
  groupSort: 'json_stock_group-sort',
  // 自选管理 - 分组排序（旧接口）
  sortSubGroup: 'json_stock_sort-sub-group',
  // 自选管理 - 分组下的股票列表
  userGroupOptional: 'json_stock_user-group-optional',
  // 自选管理 - 新增自选并加入分组
  addStockAttention: 'json_stock_add-attention',
  // 自选管理 - 个股导出
  stockExport: 'json_stock_export',
  // 自选管理 - 置顶/置底
  pinSubGroupItem: 'json_stock_pin-sub-group-item',
  // 自选管理 - 分组中移除指定个股
  deleteSubGroupItem: 'json_stock_delete-sub-group-item',
  // 自选管理 - 添加到其他分组
  copySubGroupItem: 'json_stock_copy-sub-group-item',
  /**
   * 查询分组项（/json/stock/item-list）
   */
  stockItemListOfGroupId: 'json_stock_item-list',
  /**
   * 分组项操作：移除/取消自选/置顶/置底（/json/stock/item-action）
   */
  stockItemActionOfGroupId: 'json_stock_item-action',
  /**
   * 分组项排序（/json/stock/item-sort）
   */
  stockItemSortOfGroupId: 'json_stock_item-sort',
  /**
   * 批量添加个股到分组（/json/stock/item-batch-add）
   * @see 自选分组重构前端接口文档 §6.4
   */
  stockItemBatchAddOfGroupId: 'json_stock_item-batch-add',
  // 自选管理 - 分组内全部排序（旧）
  sortTotalSubGroupItem: 'json_stock_sub-sort',
  // 自选管理 - 分组内排序（旧）
  sortSubGroupItem: 'json_stock_sort-sub-group-item',
  // 自选管理 - 分组数量统计
  countSubGroup: 'json_stock_count-sub-group',
  // 自选管理 - 全部分组股票删除
  cancelStock: 'json_stock_cancel-stock',
  /** 自选个股分页（/json/attention/queryAttentionStockPage） */
  queryAttentionStockPage: 'json_attention_query-attention-stock-page',
  /**
   * BRM 非分页查询多个分组关注股票（/json/attention/query-attention-stock-group）
   * @see 自选分组重构前端接口文档 §7.1
   */
  queryAttentionStockGroup: 'json_attention_query-attention-stock-group',
  /** 查询当前休市提示（/json/attention/query-market-tips） */
  queryMarketTips: 'json_attention_query-market-tips',
  /** 用户浏览的个股列表（/manage/stock/list-user-browse）http://yapi.comein.cn/project/293/interface/api/100260 */
  listUserBrowse: 'json_stock_list-user-browse',
  // 分组概览
  stockGroupOverview: 'json_stock-group_overview',
  // 分组概览-研报列表
  stockGroupReportList: 'json_stock-group_research-report-list',
  // 分组概览-调研列表
  stockGroupResearchList: 'json_stock-group_research-activity-list',
  // 分组概览-路演列表
  stockGroupRoadshowList: 'json_stock-group_roadshow-list',
  // 自助会议 活动-路演-推荐-自选 列表（自助会议）
  stockGroupRoadshowMeetList: 'json_stock-group_meetingactivity-list',
  // 分组概览-业绩公告列表
  stockGroupEarningsList: 'json_stock-group_earnings-list',
  // 分组概览-全部公告列表
  stockGroupAnnouncementsList: 'json_stock-group_announcement-list',
  // 分组概览-资讯列表
  stockGroupNewsList: 'json_stock-group_news-list',
  // 公告分类列表
  queryAnnouncementCategory: '/brm/announcement/list/category',
  // 公告分类查询
  queryAnnouncementListByPid: '/brm/announcement/list/listByPid',
  // 个股列表确认关注
  confirmStocksOptional: 'manage_stock_confirm-stocks-optional',
  // 自选-大模型统一识别提交
  llmImportStocks: 'json_stock_llm-import-stocks',
  // 自选-大模型统一识别结果查询
  llmImportStocksResult: 'json_stock_llm-import-stocks-result',
  // 自选-大模型查询最新任务
  llmImportStocksLatest: 'json_stock_llm-import-stocks-latest',
  // 自选-大模型标记识别结果已处理
  llmImportStocksMarkProcessed: 'json_stock_llm-import-stocks-mark-processed',
  // 分组概览-业绩日历
  earningsCalendarList: 'json_stock-group_earnings-calendar-list',
  // 路演业绩日历
  roadshowCalendarList: 'json_stock-financial-report_earnings-roadshow-calendar-list',
  // 业绩披露日历
  reportCalendarList: 'json_stock-financial-report_earnings-report-calendar-list',
  // 路演业绩日历(月视图)
  roadshowCalendarListMonth: 'json_stock-financial-report_earnings-roadshow-calendar-list-specified',
  // 业绩披露日历(月视图)
  reportCalendarListMonth: 'json_stock-financial-report_earnings-report-calendar-list-specified',
  // 财报业绩日历按天统计
  countEarningsReportCalendar: 'json_stock-financial-report_count-earnings-report-calendar',
  // 业绩路演日历按天统计
  countEarningsRoadshowCalendar: 'json_stock-financial-report_count-earnings-roadshow-calendar',
  // 会议活动列表
  meetingActivityList: 'json_meetingactivity_list',
  // 推广活动业绩日历按天统计数量
  meetingActivityCalendar: 'json_stock-financial-report_count-earnings-meetingactivity-calendar',
  // 用户基金-股票展示列表
  fundInfoViewlist: 'json_stock-public-holdings_fund-info-view-list',
  // 用户公共持仓股票列表
  holdingsList: 'json_stock-public-holdings_holdings-list',
  //基金持仓更新
  checkUpdate: 'json_stock-public-holdings_check-update',
  // 保持持仓更新信息
  keepUpdateInfo: 'json_stock-public-holdings_update-change-status',
  // 我的分组自选
  favoriteStockList: 'json_stock_user-group-optional',
  // 热门股票推荐
  hotStockList: 'json_stock_hotstock-recommend'
};
//资讯
export const news = {
  jsonNewsMacros: 'json_news_macros',
  jsonNewsIndustry: 'json_news_industry',
  jsonNewsMyself: 'json_news_myself',
  jsonNewsOrder: 'json_news_order',
  jsonNewsListOrder: 'json_news_list-order',
  jsonNewsCountOrder: 'json_news_count-order',
  jsonNewsDeleteOrder: 'json_news_delete-order',
  jsonNewsDeleteAllOrder: 'json_news_delete-all-order',
  jsonNewsListByCode: 'json_news_list-by-code',
  jsonNewDetail: 'json_news_detail',
  jsonNewListHistory: 'json_news_list-history',
  jsonNewCountHistory: 'json_news_count-history',
  jsonNewDeleteHistory: 'json_news_history-out',
  jsonNewDeleteAllHistory: 'json_news_history-all-out',
  // 公众号文章列表页
  articleList: 'json_news_article-list',
  // 我的订阅公众号列表页
  officialAccountListSubscription: 'json_news_official-account-list-subscription',
  // 推荐公众号列表页
  officialAccountListRecommendation: 'json_news_official-account-list-recommendation',
  // 公众号订阅操作
  officialAccountSubscription: 'json_news_official-account-subscription',
  // 热门新闻列表页
  hotNewsList: 'json_news_hot-news',
  // 公众号主页
  officialAccountDetail: 'json_news_official-account-detail',
  // 全部公众号列表页
  officialAccountListAll: 'json_news_official-account-list-all',
  // 财经新闻列表
  financialNewsList: 'json_news_financial-list',
  // 已订阅公众号置顶操作
  officialAccountPin: 'json_news_official-account-pin',
  // 公众号订阅数量
  officialAccountSubscriptionCount: 'json_news_official-account-subscription-count',
  // 清除公众号未读
  officialAccountClearUnread: 'json_news_official-account-all-read',
  // 公众号文章链接订阅公众号
  officialAccountUrlSubscription: 'json_news_official-account-url-subscription',
  // 文章V2-推广位内容列表（/json/article-v2/promotionlist）
  promotionNewsList: 'json_article-v2_promotionlist',
  // 文章V2-详情（/json/article-v2/detail）
  promotionNewsDetail: 'json_article-v2_detail'
};

// 会议
export const meeting = {
  // 取消报名
  cancelSignUp: 'json_self_cancel-meeting-enroll',
  myRecords: 'json_transcribe-file_list',
  signUp: 'json_self_submit-self-help-meet-enroll',
  deleteHistoryMeeting: 'json_selfmeet_delete-history-brm',
  meetingInfo: 'json_self_get-self-help-meet-enroll',
  meetingSummaryDocList: 'json_summary-user_list',
  updateMeetingSummaryDocName: 'json_summary-user_update',
  deleteMeetingSummaryDoc: 'json_summary-user_delete',
  getMeetingSummaryDocTransStatus: 'json_summary-user_transfer-status',
  getMeetingSummaryDocListByMeetingId: 'json_summary-user_list-by-meeting',
  deleteRecord: 'json_transcribe-file_delete',
  institutionMeetList: 'json_self-help-meet-brm_institution-meet-list',
  getInstitutionPushConfig: 'json_self-help-meet-brm_get-institution-push-config',
  setInstitutionPushConfig: 'json_self-help-meet-brm_set-institution-push-config',
  orgPartnerList: 'json_org-partner_list',
  orgPartnerCount: 'json_org-partner_count',
  orgPartnerAddbatch: 'json_org-partner_add-batch',
  institutionAppointment: 'json_self-help-meet-brm_institution-appointment',
  getMeetingUserList: 'json_brm-meeting_org-meeting-user-list', //自助会议-机构用户激活信息-列表查询
  getTranscribeFileRecordingList: 'json_transcribe-file_recording-list', //录会管理列表接口
  getTranscribeFileExportRecordingFiles: 'json_transcribe-file_export-recording-files', //批量导出下载信息
  getSelfmeetSelectMemberList: 'json_selfmeet_select-member-list', //BRM查询参会成员列表
  getSelfmeetExportMemberList: 'json_selfmeet_export-member-list', //BRM批量导出下载信息
  setSelfmeetEnableForceRecord: 'json_selfmeet_enable-force-record', //启用/关闭强制录制 1:启用 0:关闭
  getSelfmeetQueryForceRecordStatus: 'json_selfmeet_query-force-record-status', //查询强制录制状态
  getMeetingAccountNum: 'json_brm-meeting_org-meeting-account-info', //账号数量相关查询
  getMeetingConfig: 'json_brm-meeting_org-meeting-config', //企业套餐查询
  meetingAccountActivateCancel: 'json_brm-meeting_org-meeting-unbind', //自助会议--账号激活
  meetingAccountActivate: 'json_brm-meeting_org-meeting-bind', //自助会议--取消激活

  meetingAccountChangeNickname: 'json_user_batch-update-uname', //入会姓名修改
  meetingAccountBatchModifyUser: 'json_selfmeet_batch-modify-user', //批量修改入会用户信息
  virtualRoomList: 'json_selfmeet_select-user-virtual-meeting-room', //BRM查询用户虚拟会议室资源
  setVirtualRoom: 'json_selfmeet_set-user-virtual-meeting-room', //BRM设置用户虚拟会议室资源
  removeVirtualRoom: 'json_selfmeet_remove-user-virtual-meeting-room', //BRM移除用户虚拟会议室资源
  memberVirtualRoom: 'json_selfmeet_select-member-list', //BRM查询参会成员列表

  checkMeetingPermission: 'json_brm-meeting_brm-meeting-permission', //自助会议--判断用户是否有腾讯会议权限
  comingMeeting: 'json_self-help-meet_user-coming-list', //自助会议--即将召开的会议
  historyMeeting: 'json_self-help-meet_user-end-list', //自助会议--历史会议
  autoSignUp: 'json_meetingactivity_auto-sign', // 自动报名
  meetDetail: 'json_self_get-meet-details', // 自助会议（推广）详情
  meetingAccountInviteActivation: 'json_brm-meeting_brm-meeting-invite-activate-user' // 邀请激活
};
// 录音
export const recorder = {
  // 创建任务
  createTask: 'json_recording_create-task',
  // 创建任务
  createTaskTransReal: 'json_recording_trans-real',
  // 修改状态
  updateStatus: 'json_recording_update-status',
  // 修改名称
  update: 'json_recording_update',
  // 心跳
  reportHeartbeat: 'json_recording_heartbeat',
  // 获取录音语言
  getRecordingLanguages: 'json_recording_languages',
  recordingStopCancel: 'json_recording_stop-cancel',
  recordingRename: 'json_recording_rename',
  recordingGetUploadInfo: 'json_recording_get-upload-info'
};
// 成员推送
export const maillist = {
  addContactSetting: 'json_org-settings_add-sync-contact-setting',
  getContactSetting: 'json_org-settings_get-sync-contact-setting',
  getfieldsSetting: 'json_org-settings_get-sync-fields-config',
  getRecords: 'json_org-settings_get-sync-records',
  getRecordsId: 'json_org-settings_get-sync-records-by-task-id',
  getUpdateStatus: 'json_org-settings_update-status',
  getCountTaskId: 'json_org-settings_get-sync-count-by-task-id',
  getRecordsTaskId: 'json_org-settings_get-sync-records-by-task-id'
};

// 业绩期
export const performance = {
  // 公司业绩-财务时间
  financeTime: 'json_stock-financial-report_finance-time',
  // 公司业绩-业绩报告列表
  stockFinancialReportList: 'json_stock-financial-report_list',
  // 公司业绩-最新业绩预报
  latestForecast: 'json_stock-financial-report_latest-forecast',
  // 公司业绩-路演
  roadShowStock: 'json_stock-financial-report_roadshow-list',
  // 公司业绩-纪要
  summaryStock: 'json_stock-financial-report_summary-list',
  // 推广活动列表
  meetingList: 'json_stock-financial-report_meetingactivity-list',

  // 小提琴图
  stockFdViolin: 'json_stock-financial-report_stock-fd-violin-plot',
  // 盒须图
  stockFdBoxplot: 'json_stock-financial-report_stock-fd-boxplot',
  // 财务时间
  reportFinanceTime: 'json_stock-financial-report_finance-time',
  // 业绩时间轴
  reportTimeLine: 'json_stock-financial-report_timeline',
  // 历史财务数据
  reportFinancialHistoryList: 'json_stock-financial-report_history-list',
  // 历史业绩兑现
  forecastVsActual: 'json_stock-financial-report_forecast-vs-actual',
  // 业绩盈利预测
  forecastProfit: 'json_earnings-forecast_query-profit-forecast',
  // 业绩盈利明细
  forecastProfitDetail: 'json_earnings-forecast_query-report-list',
  // 业绩盈利一致预测变化
  forecastProfitChange: 'json_earnings-forecast_query-consistent-forecast-trend',
  // 业绩预测机构列表
  queryOrganizationList: 'json_earnings-forecast_query-organization-list',
  // 业绩预测年份
  queryForecastYear: 'json_earnings-forecast_query-forecast-year',
  // 超预期列表
  reportExceedingList: 'json_stock-financial-report_exceeding-list',
  // 披露比例
  financialDisclosureRate: 'json_stock-financial-report_financial-disclosure-rate',
  // 最新业绩预报
  reportLetestForecast: 'json_stock-financial-report_latest-forecast',
  // 公告列表查询
  reportQueryAnnouncement: 'json_stock-financial-report_query-announcement-report',
  // 是否处于静默期
  isInQuietPeriod: 'json_stock-financial-report_is-in-quiet-period',
  // 是否为ST
  isST: 'json_stock-financial-report_is-st',
  // 获取最新财报
  latestReport: 'json_stock-financial-report_latest-report'
};

export const question = {
  //问答重构迁移ES版本新增
  questionList: 'json_qa_list',
  questionCount: 'json_qa_count',
  questionTop10: 'json_qa_top10-company',
  questionStockGroup: 'json_stock-group_qa-list',

  // 获取问答详情
  queryDetail: 'json_qa_detail',
  // 点赞点踩
  answerAction: 'json_qa_answer-action',
  // 新建回答
  newAnswer: 'json_qa_new-answer',
  // 获取回答草稿
  answerDraft: 'json_qa_answer-draft-detail',
  // 热门讨论
  queryHotTopic: 'json_qa_hot-topic',
  // 相似回答
  querySimilarQA: 'json_qa_similar-qa',
  // 个股模式问答列表
  queryStockQAList: 'json_qa_stock-qa-list',
  // 话题模式问答列表
  queryTopicQAList: 'json_qa_topic-qa-list',
  // 话题问答详情
  queryTopicQADetail: 'json_qa_topic-qa-details'
};

export const syncData = {
  // 数据同步列表
  dataList: 'json_user-data-sync_info',
  // 一键同步数据
  syncData: 'json_user-data-sync_click',
  // 设置提醒状态
  noticeStatus: 'json_user-data-sync_remind-switch',
  // 查询数据同步列表状态
  queryStatus: 'json_user-data-sync_query-sync-status',
  // 同步明细
  syncDetail: 'json_user-data-sync_details',
  // 用户同步信息
  userSyncInfo: 'json_user-data-sync_get-user-info',
  // 是否有新增数据
  hasData: 'json_user-data-sync_query-status',
  // 自动同步配置
  autoSyncConfig: 'json_auto-sync_config',
  // 自动同步开启
  autoSyncOpen: 'json_auto-sync_open',
  // 自动同步关闭
  autoSyncClose: 'json_auto-sync_close'
};

export const deepResearch = {
  // 深度研究
  //公司的主营构成列表
  mainBusinessList: 'json_stock-deep-research_main-business-list',
  // 公司10大股东
  shareholder10List: 'json_stock-deep-research_shareholder-10-list',
  // 获取财务指标-同业对比-报告期截面
  getFinDataList: 'json_stock-deep-research_get-fin-data-list',
  // 获取财务指标-同业对比-单一指标
  getFinIndicatorDataList: 'json_stock-deep-research_get-fin-indicator-data-list',
  // 动量因子
  getExpWgtReturn6mList: 'json_stock-deep-research_get-exp-wgt-return-6m-list',
  // 个股的基金持仓列表
  getHoldFundList: 'json_stock-deep-research_get-hold-fund-list',
  // 基金持仓个股排名
  fundStockRank: 'json_stock-deep-research_fund-stock-rank',
  // 最新的基金持仓报告期
  getHoldFundLatestReportDate: 'json_stock-deep-research_get-hold-fund-latest-report-date',
  // 估值指标列表
  getValuationAnalysisList: 'json_stock-deep-research_get-valuation-analysis-list',
  // 融资融券列表
  getMarginTradingAndSecuritiesLendingList: 'json_stock-deep-research_get-margin-trading-and-securities-lending-list',
  // 融资融券数量统计
  countMarginTradingAndSecuritiesLending: 'json_stock-deep-research_count-margin-trading-and-securities-lending',
  // 同业公司列表
  sameIndustryCompanyList: 'json_stock-deep-research_same-industry-company-list',
  // 获取已勾选对比公司
  selectedCompanyList: 'json_stock-deep-research_selected-company-list',
  // 保存已勾选的公司列表
  saveSelectedCompanyList: 'json_stock-deep-research_save-selected-company-list',
  // 获取每日估值指标列表
  selectStocksEvaluationList: 'json_stock-deep-research_select-stocks-evaluation-list',
  // 个股相关公募基金持仓
  getFundHoldingsList: 'json_stock-deep-research_fund-holdings',
  // 行业持仓信息查询
  getIndustryHoldingsList: 'json_stock-deep-research_industry-holdings'
};

export const translation = {
  // 获取支持语言
  supportLanguage: 'json_research-report-trans_support-language',
  // 创建翻译任务
  createTranslate: 'json_research-report-trans_translate',
  // 获取翻译结果
  getTranslateResult: 'json_research-report-trans_get-translate-result',
  // 翻译列表
  translateList: 'json_research-report-trans_get-translate-list',
  // 删除记录
  deleteTranslate: 'json_research-report-trans_delete',
  // 状态变更
  changeStatus: 'json_research-report-trans_user-status-change',
  // 内资研报 - 创建翻译任务
  createReportTranslate: 'json_research-report-trans_translate-research'
};

export const statis = {
  // 笔记统计列表（根据路演/研报/策略id去统计）
  statisByNote: 'json_statis_statis-by-note',
  // 笔记统计明细（根据用户id统计）
  DetailByNote: 'json_statis_detail-by-note',
  // 笔记统计列表（根据路演/研报/策略id去统计）导出
  exportStatisByNote: 'json_export_statis-by-note',
  // 员工笔记统计列表（根据路演/研报/策略id去统计）导出
  exportUserStatisByNote: 'json_export_statis-by-note-emps',
  // 笔记统计明细列表（根据用户id统计）导出
  exportDetailByNote: 'json_export_detail-by-note',

  // 获取纪要统计数据
  statisSummaryList: 'json_brm-statistics_summary-list',
  // 获取研报统计数据
  statisResearchList: 'json_brm-statistics_research-list',
  // 获取资讯统计数据
  statisNewsList: 'json_brm-statistics_new-list',
  // 获取外资研报统计数据
  statisOverseaResearchList: 'json_brm-statistics_oversea-research-list',
  // 查询会议录制统计列表
  statisRecordList: 'json_meeting-recording-stats_stats-list',
  // 查询会议录制统计列表
  checkOrgShareEnabled: 'json_meeting-recording_check-org-share-enabled',
  // 查询AI笔记统计列表
  statisAiNoteList: 'json_ai-note-stats_stats-list',

  // 获取纪要统计明细
  statisSummaryDetail: 'json_brm-statistics_summary-sts-detail',
  // 获取研报统计明细
  statisResearchDetail: 'json_brm-statistics_research-sts-detail',
  // 获取资讯统计明细
  statisNewsDetail: 'json_brm-statistics_new-sts-detail',
  // 获取外资研报统计明细
  statisOverseaResearchDetail: 'json_brm-statistics_oversea-research-sts-detail',
  // 查询会议录制明细列表
  statisRecordDetail: 'json_meeting-recording-stats_detail-list',
  // 查询AI笔记明细列表
  statisAiNoteDetail: 'json_ai-note-stats_detail-list',
  // 查询AI笔记员工明细统计列表
  statisAiNotePersonList: 'json_ai-note-stats_stats-list-person',
  // 获取AI参会数量统计
  statisticsAiNote: 'json_ai-note_get-statistics',
  // 获取录会数量统计
  statisticsMeetingRecording: 'json_meeting-recording_statistics',
  // 转写/录音数量统计
  statisticsSummary: 'json_summary_statistics',
  // 翻译数量统计
  statisticsResearchReportTrans: 'json_research-report-trans_statistics',

  // 获取当前用户纪要统计数据
  userSummaryDetail: 'json_emps_summary-list',
  // 获取当前用户研报统计数据
  userResearchDetail: 'json_emps_research-list',
  // 获取当前用户资讯统计数据
  userNewsDetail: 'json_emps_new-list',
  // 获取当前用户外资研报统计数据
  userOverseaResearchDetail: 'json_emps_oversea-research-list',

  // 导出纪要统计明细
  exportSummaryDetail: 'json_brm-statistics_export-summary-detail',
  // 导出研报统计明细
  exportResearchDetail: 'json_brm-statistics_export-research-detail',
  // 导出资讯统计明细
  exportNewsDetail: 'json_brm-statistics_export-new-detail',
  // 导出外资资讯统计明细
  exportOverseaResearchDetail: 'json_brm-statistics_export-oversea-research-detail',
  // 导出会议录制明细列表
  exportRecordDetail: 'json_meeting-recording-stats_export-details',
  // 导出AI笔记明细列表
  exportAiNoteDetail: 'json_ai-note-stats_export-details',

  // 导出纪要统计列表
  exportSummaryList: 'json_brm-statistics_export-summary-list',
  // 导出研报统计列表
  exportResearchList: 'json_brm-statistics_export-research-list',
  // 导出资讯统计列表
  exportNewsList: 'json_brm-statistics_export-new-list',
  // 导出外资资讯统计列表
  exportOverseaResearchList: 'json_brm-statistics_export-oversea-research-list',
  // 导出会议录制统计列表
  exportRecordList: 'json_meeting-recording-stats_export-stats',
  // 导出AI笔记统计列表
  exportAiNoteList: 'json_ai-note-stats_export-stats',

  // 导出员工纪要明细列表
  exportUserSummaryList: 'json_emps_export-summary-list',
  // 导出员工研报明细列表
  exportUserResearchList: 'json_emps_export-research-list',
  // 导出员工资讯明细列表
  exportUserNewsList: 'json_emps_export-new-list',
  // 导出员工外资研报资讯明细列表
  exportUserOverseaResearchList: 'json_emps_export-oversea-research-list',
  // 导出员工ai分身列表
  exporAiNotePersonList: 'json_ai-note-stats_export-details-person',

  // 員工行爲统计列表
  userBehaviorList: 'json_emps_user-behavior-list',
  // 員工行爲统计数量
  userBehaviorStatistic: 'json_emps_data-statistics',
  // 員工行爲统计列表导出
  userBehaviorExport: 'json_export_user-behavior-list',
  //获取路演统计列表
  getRoadshowList: 'json_brm-statistics_roadshow-sts',
  //路演统计用户参会明细
  userRoadshowDetail: 'json_brm-statistics_roadshow-detail',
  //路演统计员工行为明细
  userRoadshowDetailUser: 'json_brm-statistics_roadshow-detail-user',
  //导出路演统计列表
  exportRoadshowList: 'json_brm-statistics_export-roadshow-sts',
  //导出路演用户参会明细
  exportRoadshowDetail: 'json_brm-statistics_export-roadshow-detail',
  //导出路演员工参会明细
  exportRoadshowDetailUser: 'json_brm-statistics_export-roadshow-detail-user',
  //获取限时统计路演列表
  limitedTimeSts: 'json_brm-statistics_limited-time-sts',
  //导出限时回看列表
  exportLimitedTimeSts: 'json_brm-statistics_export-limited-time-sts',
  //获取限时统计用户参会明细
  limitedTimeDetail: 'json_brm-statistics_limited-time-detail',
  //获取限时统计用户参会明细
  limitedTimeDetailUser: 'json_brm-statistics_limited-time-detail-user',
  //导出限时统计用户参会明细
  exportLimitedTimeStsDetail: 'json_brm-statistics_export-limited-time-detail',
  //导出限时统计用户参会明细
  exportLimitedTimeStsDetailUser: 'json_brm-statistics_export-limited-time-detail-user'
};
//转写
export const transfer = {
  // 转写弹窗获取搜索下拉框
  getSearchSelect: 'json_text_related-searches',
  // 开始转写
  transfer: 'json_summary_upload-audio',
  // 获取问答列表
  quest: 'json_summary_get-qa-content',
  // 发送到邮箱
  sendToEmail: 'json_summary_send-email',
  // 消息中心列表
  messages: 'json_summary_msg-center-summary',
  // 下载全文
  outputContext: 'json_summary_summary-content-export',
  // 下载摘要和问答
  outputSummary: 'json_summary_summary-point-export',
  // 获取转写列表
  list: 'json_summary_summary-list',
  // 删除
  delete: 'json_summary_delete',
  // 获取会议全文
  summaryContentList: 'json_summary_summary-content-details',
  // 获取纪文件要对应精炼内容
  summaryContentDetails: 'json_summary_optimizes-summary-content-details',
  // 获取纪要精炼状态
  summaryRefinedState: 'json_summary_summary-refined-state',
  // 获取翻译信息
  summaryTranslateInfo: 'json_summary_translate-status',
  // 开始纪要翻译
  startTranslate: 'json_summary_translate-summary',
  // 重新生成精炼内容
  summaryContentRefresh: 'json_summary_optimizes-summary-content-refresh',
  // 导出转写纪要精炼内容
  refiningSummaryContentExport: 'json_summary_refining-summary-content-export',
  // 获取纪文件要对应章节速览
  summaryContentChapter: 'json_summary_summary-content-chapter',
  // 获取纪要文件要对应指标数据
  summaryContentIndex: 'json_summary_summary-content-index',
  // 纪要任务重新生成
  summaryTaskRefreshTask: 'json_summary_summary-task-refresh',
  // 查询要点总结
  querySummary: 'json_summary-point_query-summary-points',
  // 生成要点总结
  buildSummaryPoint: 'json_summary-point_build-summary-point',
  // 溯源要点总结
  summaryPointQueryTrace: 'json_summary-point_query-summary-points-trace',
  // 未读消息数量
  summaryMsgCount: 'json_summary_summary-msg-count',
  // 改变未读消息状态为已读
  summaryMsgChange: 'json_summary_summary-msg-change',
  // 回放未读消息数量
  brmMsgCount: 'json_brm-msg_count',
  // 改变回放未读消息状态为已读
  brmMsgRead: 'json_brm-msg_read',
  // 详情
  detail: 'json_summary_summary-detail',
  // 更新纪要标题
  updateSummary: 'json_summary-user_update',
  // 更新纪要内容
  updateSummaryContent: 'json_summary_summary-content-update',
  // 更新纪要发言人
  updateSummarySpeakerName: 'json_summary_summary-spk-number-update',
  // 重试转写
  reTransfer: 'json_summary_re-build-summary',
  // 回放通知
  getReplay: 'json_brm-msg_list',
  // 转写前校验（牛币余额等）
  transcribeValidate: 'json_transcribe_validate'
};

//笔记
export const note = {
  // 获取笔记列表
  getList: 'json_note_list',
  create: 'json_note_create', //我的笔记 - 创建
  updateContent: 'json_note_update-detail', //我的笔记 - 修改内容
  update: 'json_note_update', //我的笔记 - 修改非内容信息
  detail: 'json_note_get',
  group: 'json_note_group',
  delete: 'json_note_delete',
  batchDelete: 'json_note_delete-batch',
  business: 'json_note_get-business',
  export: 'json_note_export',
  documentAuth: 'json_documents_document-auth' //文档权限
};

//云文档
export const cloudDocument = {
  //我的笔记 - 重命名、 //会议纪要 - 重命名
  renameMyNotesList: 'json_note_update-title',
  //我的笔记 - 创建副本
  copyeMyNotesList: 'json_note_create-copy',
  stockList: 'json_stock_all-list', // 股票列表查询（所有）
  //会议纪要 - 列表
  queryMeetingNotesList: 'json_meeting-summary-note_list',
  // 文档分页列表
  docList: 'json_documents_list',
  // 全量文件夹树查询
  folderTree: 'json_documents_folder-tree',
  // 文档全局搜索
  docSearch: 'json_documents_search',
  // 文档详情
  docDetail: 'json_documents_detail',
  // 文档获取父级
  docGetParent: 'json_documents_parent-list',
  // 文档权限批量设置
  docSetPermiss: 'json_documents_permissions',
  // 文档权限列表查询
  docGetPermiss: 'json_documents_permissions-list',
  // 文档新建
  docCreate: 'json_documents_create-document',
  // 文档上传
  docUpload: 'json_documents_upload-document',
  // 文档编辑
  docEdit: 'json_documents_edit-document',
  // 文档删除
  docDel: 'json_documents_del-document',
  // 文档置顶
  docSetTopUp: 'json_documents_set-topup',
  // 模糊搜索部门、员工
  searchDeptUser: 'json_documents_search-dept-user',
  // 获取共享知识库置顶列表
  knowledgeTopList: 'json_documents_document-top-list',
  // 移动
  docMove: 'json_documents_move-document',
  //文件夹和文件分享
  docShare: 'json_documents_share-document',
  // 创建副本
  docClone: 'json_documents_create-copy',
  // 最近文档列表
  docRecentList: 'json_documents_recent-list',
  // 文件夹下所有文件信息统计
  folderDocStatic: 'json_documents_folder-list',
  // 文档下载
  docDownload: 'json_documents_download-list',
  // 批量下载（异步打包）
  docBatchDownloadAsync: 'json_documents_batch-download-list-zip-async',
  // 异步下载任务重试
  docBatchDownloadRetry: 'json_documents_batch-download-list-zip-async-retry',
  // 异步下载任务取消
  docBatchDownloadCancel: 'json_documents_batch-download-list-zip-async-cancel',
  // 异步下载任务列表
  docAsyncDownloadTaskList: 'json_documents_async-download-task-batch-query',
  // 文档打开记录
  openDocument: 'json_documents_open',
  // 添加文档到知识库
  addDocumentKnowledge: 'json_documents_add-document-knowledge',
  // 获取云文档外部分享列表
  getExternalShareList: 'json_documents_search-dept-user-out',
  // 添加云文档外部分享
  addExternalShare: 'json_documents_permission-invite',
  // 云文档未读消息数量
  docMsgCount: 'json_documents_permission-apply-unread-count',
  // 云文档未读消息状态为已读
  notificationMsgRead: 'json_documents_permission-apply-read',
  // 云文档消息通知列表
  getDocNotifyList: 'json_documents_permission-apply-list',
  // 云文档消息通知 - 同意/驳回
  processDocPermission: 'json_documents_permission-handle',
  // 文档详情校验
  docDetailCheck: 'json_documents_cloud-document-access',
  // 申请云文档权限
  applyDocPermission: 'json_documents_permission-apply',
  // 云文档外部分享权限删除
  deleteExternalPermission: 'json_documents_permission-apply-del',
  // 微信助手机器人二维码 + 引导文案
  wechatBotQrcode: 'json_wechat-bot_qrcode',
  // 主页初始化
  documentHomeInit: 'json_document_home-init',
  // 分区文档列表
  documentSectionList: 'json_document_section-list'
};

// 云文档标签
export const cloudDocumentTag = {
  // 自定义标签分页搜索
  getTagCustom: 'json_documents_custom-page',
  // 批量新增自定义标签
  customBatchAdd: 'json_documents_custom-batch-add',
  // 批量删除自定义标签
  customBatchDelete: 'json_documents_custom-batch-delete',
  // 批量修改自定义标签
  customBatchUpdate: 'json_documents_custom-batch-update',
  // 行业标签分页搜索
  getTagIndustry: 'json_tag_industry',
  // 查询云文档已关联的标签列表
  documentTags: 'json_documents_document-tags',
  // 云文档关联标签（按照表单批量覆盖）
  documentAssociate: 'json_documents_associate',
  // 云文档关联标签（多文档批量追加，入参与取消关联一致）
  documentRelate: 'json_documents_relate',
  // 云文档取消关联标签
  documentsUnrelate: 'json_documents_unrelate',
  // 获取用户自选个股数据
  userOption: 'json_stock_user-optional',
  // 查询常用标签列表
  documentTagsCommonList: 'json_documents_common-list',
  // 新增常用标签
  addCommonTags: 'json_documents_common-add',
  // 删除常用标签
  cancelCommonTags: 'json_documents_common-cancel',
  // 获取标签关联数量统计
  tagRelateCount: 'json_documents_relate-count',
  // 批量查询文档 AI 打标状态（列表页轮询用）
  aiTagStatus: 'json_documents_ai-tag-status'
};

//石墨云文档
export const shimoDocument = {
  // 获取石墨token,签名信息
  getShimoToken: 'json_shimo-documents_get-credentials',
  // 获取石墨文档预览url
  getShimoDocumentPreviewUrl: 'json_shimo-documents_preview-url',
  // 获取石墨文档预览url - 支持选定预览模式
  setShimoDocumentPreviewMode: 'json_shimo-documents_set-preview-type',
  // 创建石墨文档
  createShimoDocument: 'json_documents_create-document',
  // 编辑文件、文件夹、重命名
  shimoDocumentEdit: 'json_documents_edit-document'
};

// 研究模式 - 轻文档协同（Tiptap + Hocuspocus / Yjs）
// 已知后端错误码：
//   11424 - 文件类型不支持，请上传 doc/docx/md/txt/html
//   11431 - 该文件不是 YJS 在线编辑文档
//   11434 - 文档已被更新，请重新打开后再试
//   11435 - 协同连接已过期，请重新打开文档
export const researchModelYjs = {
  // 打开 / 续连 yjs 协同会话，返回 roomId / wsUrl / accessToken / revisionNo / permission / editorEngine
  yjsOpen: 'json_research-model_yjs-open',
  // YJS / HTML Source 历史版本列表（参数：docNodeId / page / pageSize / snapSources?）
  docSnapList: 'json_research-model_doc-snap-list',
  // 手动创建历史版本（参数：docNodeId / versionName? / snapSource=1 / remark?）
  docSnapCreate: 'json_research-model_doc-snap-create',
  // 预览历史版本（参数：docNodeId / snapId），返回 html / plainText
  docSnapPreview: 'json_research-model_doc-snap-preview',
  // 恢复历史版本（参数：docNodeId / snapId / backupBeforeRestore?）
  docSnapRestore: 'json_research-model_doc-snap-restore',
  // 打开 SpreadJS 协同表格会话（参数：docNodeId），返回 roomId / wsUrl / collaborationPath / accessToken / revisionNo / permission / editorEngine
  spreadOpen: 'json_research-model_spread-open',
  // SpreadJS 最新 OT 操作日志列表（历史记录，参数：docNodeId），返回 [{ roomId, version, operation }]
  spreadOtOperationsList: 'json_research-model_spread-latest-ops',
  // SpreadJS AI 修改全部确认（参数：docNodeId）
  spreadAiEditConfirm: 'json_research-model_spread-ai-edit-confirm-all',
  // SpreadJS AI 修改版本记录列表（参数：roomId）
  spreadVersionHistoryList: 'json_research-model_spread-version-history-list',
  // SpreadJS AI 修改版本预览（参数：roomId / historyId）
  spreadVersionHistoryPreview: 'json_research-model_spread-version-history-preview',
  // SpreadJS AI 修改版本恢复（参数：roomId / historyId）
  spreadVersionHistoryRestore: 'json_research-model_spread-version-history-restore',
  // 服务端 AI 协作编辑（写回 Yjs room 后由 Hocuspocus 推送回客户端；MR2 接入，本期仅封装不暴露）
  yjsAiEdit: 'json_research-model_yjs-ai-edit',
  // 按消息 id 撤销该 message 在指定 yjs 文档上的所有 AI 编辑（参数：ownerId / docNodeId / messageId / force）
  // 返回 data.status ∈ { success, nothing_to_undo, conflict }
  yjsEditUndoByMessage: 'json_research-model_yjs-edit-undo-by-message',
  // 批量撤销最近一次 AI 修改（参数：docNodeId）：回滚最近一次 AI 改过的段落，含其后的手动编辑
  // 返回 data.status ∈ { success, nothing_to_undo, conflict }
  yjsEditBatchUndo: 'json_research-model_yjs-edit-batch-undo',
  // 批量确认 AI 修改（参数：ownerId / docNodeId / changeIds）
  yjsEditBatchAccept: 'json_research-model_yjs-edit-batch-accept',
  // 在指定父节点下创建一份空的 yjs 轻文档（参数：ownerId / parentId / name），返回新建节点信息
  createYjsFile: 'json_research-model_node-create-yjs-file',
  // 通过节点 id 拿石墨预览 URL（用于无 shimoFileId 的导入文件等场景；返回 previewUrl/可选 fileId）
  getNodeShimoPreviewUrl: 'json_research-model_node-shimo-preview-url',
  // YJS 轻文档导出下载（参数：nodeId / format）
  yjsDownload: 'json_research-model_yjs-download',
  onlyOfficeConfig: 'json_research-model_onlyoffice-config',
  // ONLYOFFICE 官方版本历史列表（参数：docNodeId / page / pageSize）
  onlyOfficeHistoryList: 'json_research-model_onlyoffice-history-list',
  // ONLYOFFICE 官方版本历史快照数据（参数：docNodeId / snapId）
  onlyOfficeHistoryData: 'json_research-model_onlyoffice-history-data',
  // ONLYOFFICE 官方版本历史恢复（参数：docNodeId / snapId）
  onlyOfficeHistoryRestore: 'json_research-model_onlyoffice-history-restore',
  // 石墨文档导出下载（参数：nodeId / format），返回 url 等下载信息
  nodeShimoDownload: 'json_research-model_node-shimo-download',
  // 资料节点统一下载（参数：docNodeId / downloadType），兼容所有文件类型
  nodeDownload: 'json_research-model_node-download'
};

// 自选行业
export const industry = {
  // 获取指数表现数据
  getIndexPerformance: 'json_macro_get-index-performance',
  // 获取行业表现
  getIndustryPerformance: 'json_macro_get-industry-performance',
  // 获取行业拥挤度
  getIndustryCrowded: 'json_macro_get-industry-crowded',
  // 日涨跌
  getDailyRiseFall: 'json_macro_get-daily-rise-fall',
  // PE
  getPe: 'json_macro_get-pe',
  // 按天统计场次
  roadshowStaticDays: 'json_roadshow_static-days',
  // 行业每日收盘价
  industryDailyClose: 'json_macro_industry-daily-close',
  // 行业行为
  industryBehavior: 'json_macro_industry-behavior',
  // 跌涨前10
  topDownTenStock: 'json_macro_top-down-10-stock',
  //
  getRangePercentageChangeList: 'json_macro_get-range-percentage-change-List',
  //行业公司热度
  getIndustryCompanyHotList: 'json_macro_get-industry-company-hot-list',
  // 成分股
  getStockTradeData: 'json_statistics-day_get-stock-trade-data',
  // 行业下的业绩前top的公司
  performanceTopCompany: 'json_stock-financial-report_performance-top-company',
  // 根据输入解析行业
  findIndustryByInput: 'json_industry_find-industry-by-input',
  // 行业详情
  industryInfo: 'json_industry_industry-info',
  //根据行业类别获取行业最新交易信息
  industryTradeInfo: 'json_industry_industry-trade-info',
  // 获取用户浏览记录
  industryBrowseList: 'json_industry_browse-industry',
  //获取用户关注行业交易信息
  followIndustryTradeInfo: 'json_industry_follow-industry-trade-info',
  // 获取用户关注行业
  industryFollow: 'json_industry_follow-industry',
  // 获取不同市场行业列表
  industryList: 'json_industry_industry-list',
  // 根据初级行业获取一级行业
  getFirstIndustryBySuperId: 'json_industry_first-industry-by-super-id'
};

//异常用户安全认证
export const securityAuth = {
  sendSecurityCode: 'json_waf_send-code',
  checkSecurityCode: 'json_waf_verify-code'
};

//AI帮记
export const aiNote = {
  // 提交帮记
  addAiNote: 'json_ai-note_add-request',
  // 校验 AI 分身参会权益
  validateAvatarBenefit: 'json_ai-note_validate-note-benefit',
  // 获取列表
  getAiNoteList: 'json_ai-note_get-ai-note-list',
  // 重命名帮记
  renameAiNote: 'json_ai-note_update-title',
  // 删除帮记
  delAiNote: 'json_ai-note_delete-by-id',
  batchDelAiNote: 'json_ai-note_delete-by-ids', //批量删除
  // 复制帮记
  copyAiNote: 'json_ai-note_copy-by-id',
  // 获取历史数量
  getAiNoteCount: 'json_ai-note_status-count-statistics',
  // 获取历史列表
  getAiNoteHistoryList: 'json_ai-note-daily_get-config-history',
  // 对比页路演信息
  getAiNoteRoadshowInfo: 'json_ai-note_roadshow-info',
  // 纪要全文
  getAiNoteSummaryContext: 'json_ai-note_summary-context',
  // 要点总结
  getAiNoteSummaryPoint: 'json_ai-note_summary-point',
  // ai会记任务列表
  getAiNoteTaskList: 'json_doc-task-management_query-task-list',
  // 批量删除任务
  deleteAiNoteTask: 'json_doc-task-management_delete-ids',
  // 异常通知接口
  exceptionCount: 'json_doc-task-management_exception-count',

  // 保存AI参会任务规则
  aiNoteDailySave: 'json_ai-note-daily_rules-save-all',
  // 查询当前用户当前AI参会规则
  queryAiNoteDaily: 'json_ai-note-daily_rules-list',
  // 开启、关闭 当前用户当前规则
  switchAiNoteDaily: 'json_ai-note-daily_role-on',
  // 更新分身使用协议状态
  aiNoteUpdateAgreement: 'json_ai-note_update-avatar-agreement',
  // 检查是否已同意分身使用协议
  aiNoteCheckAgreement: 'json_ai-note_check-avatar-agreement',
  // 获取AI参会配置-消息通知(获取)
  aiNoteMsgInfo: 'json_ai-note_ai-msg-settinginfo',
  // 保存AI参会任务规则
  aiNoteMsgSetting: 'json_ai-note_ai-msg-setting',
  // 删除AI参会任务
  deleteAiNoteByRoadshowId: 'json_ai-note_delete-by-roadshowid',
  // AI参会列表-新
  aiNoteList: 'json_ai-note_ai-note-list',
  aiNoteDailyGetMeeting30dayAvg: 'json_ai-note_get-meeting-30day-avg',
  aiNoteGetUserToolSetting: 'json_ai-note_get-user-tool-setting',
  aiNoteUpdateUserToolSetting: 'json_ai-note_update-user-tool-setting'
};

export const setting = {
  // 添加机构
  addOrg: 'json_org-partner_save-update',
  // 删除机构
  deleteOrg: 'json_org-partner_delete'
};

export const aiChat = {
  // 会话回答反馈
  answerFeedback: 'json_ai-chat_answer-feedback',
  // 会话列表
  sessionList: 'json_ai-chat_session-list',
  // 推荐提问列表
  recommendQuestion: 'json_ai-chat_recommend-question',
  // 删除会话
  deleteSession: 'json_ai-chat_delete-session',
  // 获取用户设置
  getSetting: 'json_ai-chat_get-setting',
  // 保存用户设置
  saveSetting: 'json_ai-chat_save-setting',
  // 更新会话标题
  updateTitle: 'json_ai-chat_update-title',
  // 提问模板(Ai进宝+)
  templateList: 'json_ai-chat_template-list',
  // 多轮对话(流式接口)
  chat: 'json_ai-chat_chat',
  // 回答重试(流式接口)
  retry: 'json_ai-chat_retry',
  // 聊天记录列表
  chatList: 'json_ai-chat_chat-list',
  // 会话详情
  sessionDetail: 'json_ai-chat_session-detail',
  // 停止回答
  chatCancel: 'json_ai-chat_cancel',
  // 获取模型列表
  chatModels: 'json_ai-chat_models',
  // 获取模型费率
  modelTiers: 'json_ai-chat_model-tiers',
  // 会话绑定
  validChatRecord: 'json_ai-chat_valid-chat-record',
  // 上传附件到文档库
  uploadDoc: 'json_ai-chat_upload-doc',
  // 获取上传文档的解析状态
  getDocStatus: 'json_ai-chat_get-doc-status',
  // 获取oss签名
  ossSignature: 'json_brm-file_oss-signature',
  // 保存研究计划步骤
  modifyResearchPlan: 'json_ai-chat_save-deep-research-step',
  // 删除研究计划步骤
  deleteResearchPlan: 'json_ai-chat_delete-deep-research-step',
  // （纪要、研报）详情页配置信息
  getSummaryReportConfig: 'json_ai-chat_get-summary-research-report-config',
  // 获取AI进宝生成的要点
  getAichatPoints: 'json_ai-chat_get-points',
  // (纪要、研报)校验纪要、文档是否在rag库
  checkDocChunk: 'json_ai-chat_doc-chunk-exist',
  // (纪要、研报)纪要原文、文档讲解、内外资研报上传至rag
  uploadDocChunk: 'json_ai-chat_doc-chunk-upload',
  // (全局搜索)会话开启可见设置
  enableVisible: 'json_ai-chat_enable-visible',
  //mcp列表
  mcpServerList: 'json_mcp-server_list',
  //MCP Server tool 列表
  mcpServerToolList: 'json_mcp-server_fetch-tools-list',
  // 获取当前用户可用的最新 x-mcp-key
  mcpServerCurrentKey: 'json_mcp-server_current-key',
  // 获取分组卡片列表
  mcpServerServers: 'json_mcp-server_servers',
  // 获取指定分组工具列表
  mcpServerGroupTools: 'json_mcp-server_tools',
  // 获取指定分组复制配置连接信息
  mcpServerConnectionInfo: 'json_mcp-server_connection-info',
  //MCP Server 申请合作
  mcpServerApplyCooperation: 'json_mcp-server_apply-cooperation',
  // MCP 多密钥：当前用户全量密钥（无分页，分页与筛选由前端完成）
  mcpKeyList: 'json_mcp_keys',
  // MCP 多密钥：新建密钥，入参 { name, quotaNiu, remark, permissions: [{ chatMode, toolName, allowed }] }
  mcpKeyCreate: 'json_mcp_create-key',
  // MCP 多密钥：更新密钥配置（名称 / 备注 / 额度 / 权限），
  // 入参 { keyId, name, remark, quotaSpecified, quotaNiu, permissions: [{ chatMode, toolName, allowed }] }
  mcpKeyUpdate: 'json_mcp_update-key-config',
  // MCP 多密钥：停用 / 启用密钥，入参 { keyId, keyStatus }，0 禁用 1 启用
  mcpKeyStatusChange: 'json_mcp_update-key-status',
  // MCP 多密钥：删除（软删除）密钥，入参 { keyId }
  mcpKeyDelete: 'json_mcp_delete-key',
  // MCP 多密钥：重置默认密钥（仅更换 accessKey），无请求体
  mcpDefaultKeyReset: 'json_copaw_reset-mcp-key',
  // MCP 多密钥：读取指定密钥的 Tool 权限规则，入参 { keyId }
  mcpKeyToolPermissions: 'json_mcp_key-tool-permissions',
  // 获取行业列表
  searchIndustryList: 'json_ai-chat_search-industry-list',
  //获取智能体分组
  getAgentGroupList: 'json_ai-chat_agent-group-auth-list',
  // 新增会话分享
  addSessionShare: 'json_ai-chat_session-share',
  // 分享的会话详情
  getSessionShareDetail: 'json_ai-chat_session-share-detail',
  //投研大脑列表
  researchBrainList: 'json_ai-chat-thought_list',
  // 投研大脑-安装思维
  installThoughtChain: 'json_ai-chat-thought_install',
  // 投研大脑-删除思维
  deleteThoughtChain: 'json_ai-chat-thought_delete',
  // 投研大脑-获取思维链详情
  getThoughtChainDetail: 'json_ai-chat-thought_detail',
  // 投研大脑-提取思维
  extractThoughtChain: 'json_ai-chat-thought_extract',
  // 投研大脑-创建思维
  createThoughtChain: 'json_ai-chat-thought_add',
  // 投研大脑-更新思维
  updateThoughtChain: 'json_ai-chat-thought_update',
  // 投研大脑-批量上传文档
  batchUploadDoc: 'json_ai-chat_batch-upload-doc',
  // 投研大脑-获取思维链关联文档
  getThoughtChainDocs: 'json_ai-chat_get-doc-basic-info',
  // 批量删除思维链关联文档
  batchDeleteDoc: 'json_ai-chat_batch-delete-doc',
  //mcp图表json修复
  jsonRepair: 'json_text_json-repair',
  // 校验是否能启用/禁用思维
  checkEnableStatus: 'json_ai-chat-thought_change-enable-status',
  //投研大脑开关
  switchResearchBrain: 'json_ai-chat-thought_global-switch-status',
  // 获取思维链提取结果
  queryThoughtExtractResult: 'json_ai-chat-thought_extract-result',
  // 根据优化建议思维链
  optimizeThoughtChainByAdvice: 'json_ai-chat-thought_optimize',
  // 思维优化获取结果
  queryOptimizeThoughtChainResult: 'json_ai-chat-thought_optimize-result',
  //获取思维评分结果
  queryThoughtScoreResult: 'json_ai-chat-thought_score-result',
  // 润色思维
  polishThoughtChain: 'json_ai-chat-thought_polish',
  // 思维润色获取结果
  queryThoughtPolishResult: 'json_ai-chat-thought_polish-result',
  // 标签相关
  tagCreate: 'json_ai-chat_tag-create',
  tagDelete: 'json_ai-chat_tag-delete',
  tagList: 'json_ai-chat_tag-list',
  tagAll: 'json_ai-chat_tag-all',
  tagSearch: 'json_ai-chat_tag-search',
  tagUpdate: 'json_ai-chat_tag-update',
  tagPin: 'json_ai-chat_tag-pin',
  // 会话与标签关联
  sessionTagBind: 'json_ai-chat_session-tag-bind',
  sessionTagUnbind: 'json_ai-chat_session-tag-unbind',
  sessionTagList: 'json_ai-chat_session-tag-list',
  // 用户内置渠道配置（聚合）：左侧 tabs + 右侧 configMap
  thirdChannelConfigList: 'json_third-channel-config_list',
  // 用户内置渠道配置-保存：聊天 / 研究模式共用，通过 channelType 区分（任务模式走 openClawApi）
  thirdChannelConfigUpdate: 'json_third-channel-config_update',
  // 用户定时任务-新增：聊天 / 研究模式
  userSchedulerTaskAdd: 'json_user-scheduler-task_add',
  // 用户定时任务-列表：聊天 / 研究模式
  userSchedulerTaskList: 'json_user-scheduler-task_list',
  // 用户定时任务-模板列表：查询当前可用的官方任务模板
  userSchedulerTaskTemplates: 'json_user-scheduler-task_templates',
  // 用户定时任务-模板详情：按 templateKey 获取模板预设数据
  userSchedulerTaskTemplateDetail: 'json_user-scheduler-task_template-detail',
  // 用户定时任务-删除：聊天 / 研究模式
  userSchedulerTaskDelete: 'json_user-scheduler-task_delete',
  // 用户定时任务-切换启用/暂停：聊天 / 研究模式
  userSchedulerTaskToggle: 'json_user-scheduler-task_toggle',
  // 用户定时任务-更新：聊天 / 研究模式
  userSchedulerTaskUpdate: 'json_user-scheduler-task_update',
  // 用户定时任务-立即执行：仅向调度中心提交一次手动触发，不等待任务链路执行完成
  userSchedulerTaskTriggerNow: 'json_user-scheduler-task_trigger-now',
  // 用户定时任务-通知渠道选项：按 taskType 返回当前模式下可用的 IM 渠道及 contacts/conversations 预览
  userSchedulerTaskNotifyChannels: 'json_user-scheduler-task_notify-channels',
  // 第三方渠道-扫码授权：获取渠道二维码（base64）
  thirdChannelQrcodeFetch: 'json_third-channel_qrcode-fetch',
  // 第三方渠道-扫码授权：查询渠道二维码扫码状态
  thirdChannelQrcodeStatus: 'json_third-channel_qrcode-status',
  // AI 进宝-工具与连接-数据库：新增 MCP 配置（创建配置本体，并按 agentIds 建立生效关系）
  // 入参字段与任务模式 /api/copaw/mcp 的 client 子对象一致：name / transport / headers / command / args / env / cwd / remark / agentIds
  aiAssistantCreateMcpConfig: 'json_research_create-mcp-config',
  // AI 进宝-工具与连接-数据库：MCP 配置列表（平台官方 type=2 + 用户创建 type=4 合并接口）
  // 原 list-mcp-pool 已合并到本接口
  aiAssistantListMcpConfig: 'json_research_list-mcp-config',
  // AI 进宝-工具与连接-数据库：查询当前 agent 已启用的 MCP 列表
  // Query：agentId（如 research / chat / task）
  aiAssistantListAgentMcp: 'json_research_list-agent-mcp',
  // AI 进宝-研究模式-工具与连接：官网官方 MCP 连接器列表
  aiAssistantListOfficialConnector: 'json_research_list-official-connector',
  // AI 进宝-研究模式-工具与连接：切换官网官方 MCP 连接器状态
  aiAssistantToggleOfficialConnector: 'json_research_toggle-official-connector',
  // AI 进宝-工具与连接-数据库：MCP 绑定关系（bind / update / delete 由 action 区分）
  aiAssistantMcpBinding: 'json_research_mcp-binding',
  // AI 进宝-工具与连接-数据库：更新 MCP 配置（原 update-mcp-pool 已合并到本接口）
  // 入参与 create-mcp-config 一致，额外必填 id；可按 agentIds 重建绑定关系
  aiAssistantUpdateMcpConfig: 'json_research_update-mcp-config',
  // AI 进宝-工具与连接-数据库：删除 MCP 配置（按 id 删除配置本体并清理绑定，原 delete-mcp-pool 已合并到本接口）
  // 入参：{ id: integer }
  aiAssistantDeleteMcpConfig: 'json_research_delete-mcp-config',
  // AI 进宝-工具与连接-数据库：探测指定 MCP 的工具列表
  // 入参：{ mcpServerId: integer }
  aiAssistantProbeMcp: 'json_research_probe-mcp',
  // AI 进宝-工具与连接-数据库-推荐连接器：连接器市场列表
  // Query：{ status? } —— 'ALL' | 'CONNECTED' | 'PENDING'，默认 ALL
  // 返回 data[]：{ connectorId, connectorKey, name, logoUrl, desc, description, docUrl, connectType, connectionStatus, mcpServerId, enabled, useCases }
  // 注：desc 为卡片摘要文案；description 实际是文档/引导链接，非文本描述；docUrl 为详情弹窗「使用说明」外链，可能为空
  aiAssistantListMarketConnector: 'json_research_list-market-connector',
  // AI 进宝-工具与连接-数据库-推荐连接器：发起 OAuth 授权连接（仅 connectType=OAUTH 的连接器可调用）
  // 入参：{ connectorId: integer }
  // 返回 data：{ authUrl, connectionId } —— authUrl 用于跳转第三方授权页，connectionId 用于接口 4 轮询连接状态
  aiAssistantStartOauthConnect: 'json_research_start-oauth-connect',
  // AI 进宝-工具与连接-数据库-推荐连接器：查询 OAuth 连接状态（建议授权跳转后每 2s 轮询一次）
  // 入参：{ connectionId: integer } —— 接口 3 返回的 connectionId
  // 返回 data：{ status, errorMsg, mcpServerId } —— status 为 CONNECTED/ERROR/REAUTH_REQUIRED 时停止轮询；
  // errorMsg 仅 ERROR/REAUTH_REQUIRED 时有值；mcpServerId 仅 CONNECTED 时有值
  aiAssistantGetConnectionStatus: 'json_research_get-connection-status',
  // AI 进宝-工具与连接-数据库-推荐连接器：凭证型连接（仅 connectType=CREDENTIAL 的连接器可调用）
  // 入参：{ connectorId: integer, credentials: { email, authCode, host, port } }
  // 返回 data：{ status, errorMsg, mcpServerId } —— 同步返回最终结果（内部含 MCP 探测），无需轮询
  aiAssistantConnectByCredential: 'json_research_connect-by-credential',
  // AI 进宝-工具与连接-数据库-推荐连接器：断开连接（重置为 PENDING，关联 MCP Server 软删除，Agent 绑定解除）
  // 入参：{ connectorId: integer }
  // 返回 data：null
  aiAssistantCancelConnector: 'json_research_cancel-connector',
  // AI 进宝-工具与连接-技能：通过编写技能创建 workspace skill
  // 入参：{ mode, agentId, name, content, tags?, channels?, config?, enabled? }
  aiAssistantCreateSkillWorkspace: 'json_research_create-skill-workspace',
  // AI 进宝-工具与连接-技能：workspace skill 列表
  // Query：{ agentId }，如 research
  // 响应：列表项新增 skillPoolId 字段；列表中可能出现虚拟 builtin 条目（workspaceSkillId=null，仅有 skillPoolId）
  // 响应：列表项还含使用案例字段 caseQuestion / caseAnswer / caseDocumentContent，
  // 以及卡片「试用」预填用的 trialQuestion（缺失时前端不预填问题）；
  // featured=1 为精选技能，精选区按 featuredSort 升序展示（值越小越靠前，缺失排末尾）
  // 券商技能列表项还含 userAuth：当前账号是否在该券商白名单内，false 时卡片在开关旁提示权限失效
  aiAssistantListSkillWorkspace: 'json_research_list-skill-workspace',
  // AI 进宝-工具与连接-技能：workspace skill 详情
  // Query：{ workspaceSkillId?, skillPoolId? } —— 两者二选一；builtin 虚拟条目仅可用 skillPoolId
  // 响应：新增 skillPoolId；券商技能 useCondition.userAuth 为 { passed, message? }，
  // passed 非 true 时详情开关旁提示权限失效
  aiAssistantGetSkillWorkspaceDetail: 'json_research_get-skill-workspace-detail',
  // AI 进宝-工具与连接-技能：更新 workspace skill
  // 入参：{ workspaceSkillId?, skillPoolId?, name?, tags?, content?, enabled?, channels?, config? }
  // workspaceSkillId 与 skillPoolId 二选一；builtin 条目仅允许修改 enabled / tags / channels / config
  aiAssistantSaveSkillWorkspace: 'json_research_save-skill-workspace',
  // AI 进宝-工具与连接-技能：删除 workspace skill
  // 入参：{ workspaceSkillId }
  aiAssistantDeleteSkillWorkspace: 'json_research_delete-skill-workspace',
  // AI 进宝-工具与连接-技能：通过文件（OSS ZIP）导入 workspace skill
  // 入参：{ mode, agentId, ossUrl, sourceType, md5?, enabled? }
  aiAssistantImportWorkspaceSkill: 'json_research_import-workspace-skill',
  // AI 进宝-工具与连接-技能：获取自建 workspace skill 技能包的 OSS 下载信息
  // 入参：{ workspaceSkillId }，出参：{ downloadUrl, fileName }
  aiAssistantExportWorkspaceSkill: 'json_research_export-workspace-skill',
  // ── 券商研究所技能-使用条件校验（联调文档「券商 Skill 使用条件｜前端联调接口」第二节）──────
  // 券商研究所技能：一次性校验白名单、MCP 依赖、免责声明三项使用条件
  // 入参：{ skillPoolId }
  // 返回 data：{ userAuth: { passed, message? },
  //             mcp: { passed, message?, mcpServers?: [{ mcpServerId, name, description?, iconUrl, status }] },
  //             disclaimer: { passed, content? } }
  // mcpServers 仅在 mcp.passed=false 时下发，且只含未就绪项
  // passed=false 属于业务校验未通过，接口仍返回 code=0；未开启白名单的券商三项均为 true
  // 服务端按 uid + skillPoolId 缓存 10 分钟通过结果，未通过不写缓存
  aiAssistantCheckBrokerSkillCondition: 'json_research_check-broker-skill-condition',
  // 券商研究所技能：确认当前版本免责声明，仅在上一步 disclaimer.passed=false 时调用
  // 入参：{ skillPoolId }，返回 data：{ success }；确认成功后需重新调用条件校验
  aiAssistantConfirmBrokerSkillDisclaimer: 'json_research_confirm-broker-skill-disclaimer'
};

// 研究模式（CustomResearchChat）相关接口
export const researchChat = {
  // 流式对话（SSE 入口，BRM AI 服务 RESTful 路径，须以 BRM_AL_URL_HOST 拼接）
  chat: '/sse/ai-chat/research-chat',
  // 重连会话（SSE 续推，BRM AI 服务 RESTful 路径，须以 BRM_AL_URL_HOST 拼接）
  reconnect: '/sse/ai-chat/research-reconnect',
  // 手动整理 / 压缩会话上下文（SSE，BRM AI 服务 RESTful 路径，须以 BRM_AL_URL_HOST 拼接）
  compact: '/sse/ai-chat/research-compact',
  // 历史会话列表（研究模式会话分页列表 SandboxApi，支持 fileIds / search / tag / sourceChannel）
  sessionList: 'json_research_session-page',
  // 历史会话详情
  sessionDetail: 'json_research_session-detail',
  // 子 Agent 会话详情（点击查看时按需加载）
  subSessionDetail: 'json_research_sub-session-detail',
  // 会话基础信息
  sessionInfo: 'json_research_session-info',
  // 取消会话
  cancel: 'json_research_cancel',
  // 重命名会话标题
  updateTitle: 'json_research_update-title',
  // 会话置顶 / 取消置顶（同一接口按 pinned 布尔值切换）
  // 置顶后的排序由 session-page 保证（置顶项优先返回），前端不做本地排序
  pinSession: 'json_research_session-pin',
  // 删除会话
  deleteSession: 'json_research_session-delete',
  // 进行中会话快照（研究模式底部「运行会话」提示，凡返回即进行中；详见 docs/research-runtime-sessions-interface.md）
  activeSessions: 'json_research_list-active-sessions',
  // 历史会话「关联文档」筛选项列表（获取用户在 AI 会话中使用过的文档，分页，按最近相关时间倒序）
  relatedDocList: 'json_research_list-user-docs',
  // 按文档统计相关 AI 会话数
  countSessionsByDoc: 'json_research_count-sessions-by-doc',
  // 按文档分页查询相关 AI 会话
  listSessionsByDoc: 'json_research_list-sessions-by-doc',
  // 研究模式可选模型列表（「选择模型」子菜单）
  modelList: 'json_research_list-model'
};

export const memberShip = {
  // 获取商品定价
  getGoodsPrice: 'json_membership_goods-detail',
  // 二维码支付 获取二维码信息
  getOrderInfo: 'json_order_membership-qrcode',
  // 获取用户信息
  getExistInvest: 'json_user_userdetail',
  // 获取所有用户会员信息
  getAllUser: 'json_membership_query-all-user-membership',
  // 获取会员身份卡片信息
  getIdentityCards: 'json_membership_identity-cards',
  // 服务专员接口
  getExclusiveCustomer: 'json_membership-freeactivity_exclusive-customer'
};

export const nbiRecharge = {
  // 牛币充值页面-商品详情/基本信息
  getRechargeGoodsDetail: 'json_nbi_recharge-goods-detail',
  // 牛币充值-创建订单
  createRechargeOrder: 'json_nbi_create-order',
  // 牛币充值-二维码支付（创建/查询状态/查询订单）
  rechargeQrcode: 'json_nbi_qrcode',
  // 牛币充值-二维码订单详情
  rechargeQrcodeOrder: 'json_nbi_qrcode-order',
  // 牛币收支明细分页（全部/支出/收入）
  dealFlowPage: 'json_nbi_deal-flow-page',
  // 牛币明细下拉详情列表（MCP / Token 消耗明细）
  dealFlowDetailList: 'json_nbi_deal-flow-detail-list'
};

/** 活动牛币（每日签到 / 新手任务）接口 interface */
export const activityNbi = {
  // 查询当前用户各活动入口的可见性
  getActivityEntry: 'json_activity_entry',
  // 新手任务面板（资格、聚合态、任务列表与奖励进度）
  getNewbieTaskPanel: 'json_newbie-task_panel',
  // 新手任务完成上报（幂等）
  reportNewbieTaskComplete: 'json_newbie-task_complete',
  // 标记用户已查看新上线的新手任务（清除入口红点）
  reportNewbieTaskView: 'json_newbie-task_view',
  // 签到信息（今日是否已签、连续天数、奖励规则）
  getSignInInfo: 'json_sign-in_info',
  // 执行签到并发放牛币（幂等）
  doSignIn: 'json_sign-in_do'
};

export const document = {};

// 录会
export const recording = {
  // 提交代录信息
  addRecording: 'json_meeting-recording_submit',
  // 代录信息列表
  getRecordingList: 'json_meeting-recording_list',
  // 删除代录信息
  deleteRecording: 'json_meeting-recording_delete',
  // 录会协议及状态获取
  file: 'json_meeting-recording_record-agreement-file',
  // 更新使用协议状态
  update: 'json_meeting-recording_update-record-agreement'
};

/** 日报接口 interface */
export const daily = {
  /** 获取最近的日报 */
  recentDaily: 'json_dailyreport_recent-dailyreport',
  /** 往期日报列表 */
  pastDaily: 'json_dailyreport_before-list',
  /** 日报详情 */
  dailyDetail: 'json_dailyreport_report-list',
  /** 热点详情 */
  hotDetail: 'json_dailyreport_report-detail',
  /** 相关概念股票 */
  relatedConceptStocks: 'json_dailyreport_industry-chain-stock-infos',
  /** 热点列表-分页 */
  hotspotListPaging: 'json_dailyreport_hotspot-list',
  /** 日报所有热点语音 OSS 地址 */
  dailyAudioUrl: 'json_dailyreport_hotspot-voice-urls'
};
// 舆情模块
export const publicOpinion = {
  // 舆情管理用户列表 http://yapi.comein.cn/project/293/interface/api/62475
  getPublicOpinionUserList: 'json_wechat-opinion_pagelist',
  // 获取当前机构已配置的微信机器人名称 http://yapi.comein.cn/project/293/interface/api/62465
  getWeChatRobotName: 'json_wechat-opinion_query-org-bootname',
  // 获取当前组织下的微信群列表 用于配置框查询  http://yapi.comein.cn/project/293/interface/api/62470
  getWeChatGroupList: 'json_wechat-opinion_query-org-wechat-room',
  // 批量设置 http://yapi.comein.cn/project/293/interface/api/62500
  batchSetPublicOpinion: 'json_wechat-opinion_batch-setting-room',
  // 舆情管理列表  http://yapi.comein.cn/project/293/interface/api/62540
  publicOpinionList: 'json_wechat-opinion_opinion-list',
  // 舆情列表收藏  http://yapi.comein.cn/project/293/interface/api/62545
  collectPublicOpinion: 'json_wechat-opinion_favorite',
  // 舆情列表获取事件类型
  getEventTypeList: 'json_wechat-opinion_query-type',
  // 统计接口
  getPublicOpinionStatis: 'json_wechat-opinion_count-by-type',
  // 舆情详情
  getPublicOpinionDetail: 'json_wechat-opinion_detail',
  // 舆情活动-一键代录提交
  submitAiRecord: 'json_wechat-opinion_submit-recording',
  // 检查机构是否有微信群权限
  checkWeChatOpinionPermission: 'json_wechat-opinion_check-permission'
};

// 微信平台
export const wechatPlatform = {
  getWechatActivityList: 'json_wechat-opinion_opinion-list',
  switchWechatReservationStatus: 'json_wechat-opinion_appointment',
  switchWechatCollectStatus: 'json_wechat-opinion_favorite',
  getWechatActivityDetail: 'json_wechat-opinion_detail'
};

export const organization = {
  // 获取组织配置状态
  queryOrganizationWhitelistConfig: 'json_organization-whitelist_query-config',
  // 获取最后一次校验时间
  queryOrganizationWhitelistCheckTime: 'json_organization-whitelist_query-last-checktime',
  // 根据uid获取已授权的组织名称集合
  queryOrganizationWhitelistByUid: 'json_organization-whitelist_query-by-uid',

  // 导出未验证员工名单
  exportUnverifiedPartnerOrg: 'json_organization-whitelist_export-unverified-partner-org',
  // 授权组织查询
  queryOrganizationAuthOrgList: 'json_organization_auth-org-list',
  // 按分组 / 个股编码批量查询个股（常用筛选组合应用时，用于把 groupIds 父项补齐为 stockCodes 子项列表）
  queryStockByGroupOrCode: 'json_stock_query-by-group-or-code'
};

// 会员专区
export const memberZone = {
  // 获取会员专区banner列表
  getMemberZoneBannerList: 'json_ad_list',
  // 获取专属推荐列表
  getVipRecommendList: 'json_vip-recommend_list',
  // 路演-牛币兑换列表
  getRoadshowExchangeList: 'json_roadshow-list_exchange-list',
  // 调研活动-牛币兑换列表
  getResearchActivityExchangeList: 'json_activity-research_exchange-nbi-list',
  // 内资研报-牛币兑换列表
  getResearchExchangeList: 'json_research_exchange-nbi-list',
  // 点评-牛币兑换列表
  getInvestmentInsightsExchangeList: 'json_investment-insights_exchange-nbi-list',
  // 调研纪要-牛币兑换列表
  getResearchSummaryExchangeList: 'json_third-research-summary_exchange-nbi-list',
  // 已兑换内容-权益名称返回
  getContentList: 'json_benefit_content-list'
};

export const user = {
  /** 根据id编辑成员偏好设置 */
  saveUserPreference: 'json_user-preference_update-by-id',
  /** 保存偏好设置 */
  updateUserPreference: 'json_user-preference_save',
  /** 查询指定类型的成员偏好设置 */
  getUserPreferenceList: 'json_user-preference_select-list',
  // 查询用户自定义菜单配置
  getUserCustomMenu: 'json_author_query-custom-menu',
  // 自定义菜单操作
  resetCustomMenu: 'json_author_reset-custom-menu',
  setDefaultMenu: 'json_author_set-default-menu',
  saveCustomMenu: 'json_author_save-custom-menu',
  clickNewMenu: 'json_author_click-new-menu',
  // 查询当前用户需要隐藏的菜单编码列表
  getHiddenMenuCodes: 'json_author_query-hidden-menu-codes'
};

/**
 * 第三方渠道（微信 chatBot 等）相关接口
 * 服务端会将下划线分隔的 URL 路由到 /json/third-channel/<act>
 */
export const thirdChannel = {
  // 查询当前用户的第三方渠道连接状态
  connectStatus: 'json_third-channel-config_connection-status',
  // 获取扫码二维码
  qrcodeFetch: 'json_third-channel_qrcode-fetch',
  // 轮询扫码状态
  qrcodeStatus: 'json_third-channel_qrcode-status'
};

export const eventSignal = {
  // 获取事件信号
  eventSignalList: 'json_event-signal_list',
  // 溯源列表
  sourceList: 'json_event-signal_traceability-list',
  // 查询最新
  queryNew: 'json_event-signal_has-new',
  // 查询事件标签详情
  eventTagDetail: 'json_event-signal_event-tag-detail',
  // 事件基准收益率
  eventBenchmarkRate: 'json_event-signal_event-benchmark-rate',
  // 查询事件等级
  eventTagLevel: 'json_event-signal_event-tag-level',
  // 事件回测详情
  eventTriggerDetail: 'json_event-signal_event-trigger-detail',
  /** 事件库汇总（数据范围：区间、条数等），无入参 */
  eventLibrarySummary: 'json_event-signal_event-library-summary'
};

//AI进宝 - 研究模式
export const aiResearchMode = {
  // 获取在资料库列表数据
  getResourceLibraryList: 'json_research-model_workspace-overview',
  // 初始化当前登录用户的研究模式工作区配置
  workspaceInit: 'json_research-model_workspace-init',
  // 创建文件夹
  createFolder: 'json_research-model_node-create-folder',
  // 创建空白文档（自研协同编辑文件，支持 yjs 协同）
  createFile: 'json_research-model_node-create-yjs-file',
  // 创建空白 Excel 文件
  createExcel: 'json_research-model_node-create-excel',
  // 创建空白 Word 文件
  createDocx: 'json_research-model_node-create-docx',
  // 创建空白 PPT 文件
  createPpt: 'json_research-model_node-create-ppt',
  // 移动文档节点
  moveNode: 'json_research-model_node-move',
  // 查询研究任务预设文件列表
  getTaskPresetFiles: 'json_research-model_task-preset-files',
  // 删除节点
  deleteNode: 'json_research-model_node-delete',
  // 更新任务（重命名/归档）
  updateTask: 'json_research-model_task-update',
  // 更新文档节点（重命名）
  updateNode: 'json_research-model_node-update',
  // 查询单个资料节点详情（参数：id）
  nodeDetail: 'json_research-model_node-detail',
  // 查询全部收藏文件（按收藏时间倒序）
  nodeFavoriteList: 'json_research-model_favorite-file-list',
  // 查询最近浏览文件（按浏览时间倒序，最多 50 条）
  nodeRecentList: 'json_research-model_recent-view-file-list',
  // 更新文件收藏状态
  nodeFavoriteUpdate: 'json_research-model_node-favorite-update',
  // 记录文件浏览
  nodeViewRecord: 'json_research-model_node-view-record',
  // 石墨内容保存完成后触达节点，刷新资料节点 contentUpdatedAt（参数：docNodeId）
  nodeShimoContentTouch: 'json_research-model_node-shimo-content-touch',
  // ONLYOFFICE 内容保存完成后触达节点，刷新资料节点 contentUpdatedAt（参数：docNodeId）
  onlyOfficeContentTouch: 'json_research-model_onlyoffice-content-touch',
  // 批量标记资料节点 AI 修改已读 / 记录用户查看（参数：nodeIds / observedAt）
  nodeAiModifiedReadBatch: 'json_research-model_node-ai-modified-read-batch',
  // 上传文件（单文件）
  uploadFile: 'json_research-model_node-upload',
  // 批量上传文件
  batchUploadFile: 'json_research-model_node-batch-upload',
  // 搜索文档节点
  searchNode: 'json_research-model_node-search',
  // 创建研究任务
  createTask: 'json_research-model_task-create',
  // 本地文件已上传 OSS 后转存到资料库（待定）
  ingestFromOss: 'json_research-model-documents_ingest-oss',
  // 云文档转存到资料库（待定）
  ingestFromCloudDoc: 'json_research-model-documents_ingest-cloud-doc',
  // 输入框附件转存到资料库（本地文件）
  nodeArchiveUpload: 'json_research-model_node-archive-upload',
  // 输入框云文档批量归档导入资料库（参数：l1FolderId / documentIds）
  nodeBatchArchiveImportCloudDoc: 'json_research-model_node-batch-archive-import-cloud-doc',
  // 查询单个资料节点导入进度（参数：nodeId）
  nodeImportProgress: 'json_research-model_node-import-progress',
  // 按 docNodeId 数组批量反查节点 fullPath（用于研究模式 send 时拼 query.header）
  nodeFullPathBatch: 'json_research-model_node-full-path-batch',
  // 按 fullPath 数组批量反查节点 docNodeId（用于历史用户消息中的 <path> 反解为 chip）
  nodeIdByFullPathBatch: 'json_research-model_node-id-by-full-path-batch',
  // 置顶一级文件夹
  pinTaskFolder: 'json_research-model_node-folder-pin',
  // 取消置顶一级文件夹
  unpinTaskFolder: 'json_research-model_node-folder-unpin',
  // 批量从云文档导入资料
  batchImportCloudDoc: 'json_research-model_node-batch-import-cloud-doc',
  // 按 messageIds 查询本轮 API 审计摘要（流式结束后判断文件新增 / 修改）
  apiAuditSummaryQuery: 'json_research-model_api-audit-summary-query',
  // 提交节点重新进行 RAG 解析
  ragSubmit: 'json_research-model_rag-submit',
  // 批量查询节点 RAG 解析状态
  ragStatus: 'json_research-model_rag-status',
  // 研究模式文档分享：按分享码解析预览信息
  documentShareResolve: 'json_research-model_share-resolve',
  // 研究模式文档节点分享：生成短链 / 二维码内容
  nodeShareCreate: 'json_research-model_node-share-create',
  // 研究模式文档分享：按分享码免鉴权下载（后端出带 attachment 的签名下载信息）
  nodeShareDownload: 'json_research-model_node-share-download',
  // 获取研究模式用户级设置
  getKnowledgeSetting: 'json_research_get-setting',
  // 保存研究模式用户级设置
  saveKnowledgeSetting: 'json_research_save-setting',
  // 获取行业标签（研究模式，剔除"中小市值"、"海外研究"、"北交所"）
  getResearchModeIndustry: 'json_tag_research-mode-industry',
  // 股票列表分页搜索（研究模式，仅返回在市且未删除记录）
  searchResearchModeStock: 'json_stock_research-mode-search',
  // 批量下载（创建异步任务）
  nodeBatchDownloadAsync: 'json_research-model_node-batch-download-async',
  // 查询批量下载任务状态（单个，POST + Query 参数）
  batchDownloadTask: 'json_research-model_batch-download-task',
  // 批量查询下载任务详情（轮询用，POST Body 传 batchTaskIds 数组）
  batchDownloadTaskBatchQuery: 'json_research-model_batch-download-task-batch-query',
  // 批量下载失败重试（POST + Query 参数 taskId，返回新 taskId）
  batchDownloadAsyncRetry: 'json_research-model_batch-download-async-retry',
  // 批量下载取消（POST + Query 参数 taskId）
  batchDownloadAsyncCancel: 'json_research-model_batch-download-async-cancel',
  // 批量删除文档节点
  nodeBatchDelete: 'json_research-model_node-batch-delete',
  // 批量移动预检（只读，不写入）
  nodeBatchMoveCheck: 'json_research-model_node-batch-move-check',
  // 批量移动文档节点
  nodeBatchMove: 'json_research-model_node-batch-move'
};

// 资讯新动态
export const researchNews = {
  count: 'json_research-news_count',
  markRead: 'json_research-news_mark-read',
  save: 'json_research-news_resave-task-source',
  // 批量转存：同步将勾选的内容（≤50）逐条转存到当前资料，返回每条结果
  batchResave: 'json_research-news_batch-resave-task-source',
  // 动态弹框 5 个列表（透传下游 + 回填每条 resaved 是否已转存状态）
  listDomesticResearch: 'json_research-news_list-domestic-research',
  listOverseaResearch: 'json_research-news_list-oversea-research',
  listSummary: 'json_research-news_list-summary',
  listInsights: 'json_research-news_list-insights',
  listAnnouncement: 'json_research-news_list-announcement'
};

/**
 * AI 用量数据看板接口
 * 服务端会将下划线分隔的 URL 路由到 /json/ai-usage-board/<act>
 */
export const aiUsageBoard = {
  /** 机构账号用量（/json/ai-usage-board/institution-usage） */
  institutionUsage: 'json_ai-usage-board_institution-usage',
  /** 企业账号用量（/json/ai-usage-board/enterprise-usage） */
  enterpriseUsage: 'json_ai-usage-board_enterprise-usage',
  /** 企业成员列表（/json/ai-usage-board/enterprise-members） */
  enterpriseMembers: 'json_ai-usage-board_enterprise-members',
  /** 企业 MCP 调用明细（/json/ai-usage-board/enterprise-mcp-detail） */
  enterpriseMcpDetail: 'json_ai-usage-board_enterprise-mcp-detail',
  /** 企业 Token 调用明细（/json/ai-usage-board/enterprise-token-detail） */
  enterpriseTokenDetail: 'json_ai-usage-board_enterprise-token-detail'
};

export default {
  // 通用接口
  phpUrl: HOST,
  common,
  login,
  research,
  market,
  analyst,
  articlecenter,
  news,
  meeting,
  recorder,
  performance,
  question,
  strategy,
  syncData,
  note,
  statis,
  transfer,
  cloudDocument,
  securityAuth,
  aiNote,
  industry,
  setting,
  aiChat,
  recording,
  memberShip,
  daily,
  publicOpinion,
  organization,
  thirdChannel,
  aiResearchMode,
  researchNews,
  aiUsageBoard
};
